import React, {Component, lazy, Suspense} from 'react';
import Sidebar from "./Sidebar";
import Header from "./Header";

import Footer from "./Footer";
import HomePage from "../HomePage";
import {Route, Switch, withRouter} from 'react-router-dom';
import {getCurrentUser, isAuthenticated, request} from "../helper/APIUtils";
import {ACCESS_TOKEN, EntegratorConf, KEEP_SESSION_OPEN, VirtualHost} from "../constants";
import Login from "../Login";
import NotFound from "../error/NotFound";
import Redirect from "react-router-dom/es/Redirect";
import ExternalCustomerList from "../accounting/externalcustomer/ExternalCustomerList";
import CustomerList from "../accounting/customer/CustomerList";
import CreateEditCustomer from "../accounting/customer/CreateEditCustomer";
import StockList from "../accounting/stock/StockList";
import AliasSigner from '../accounting/signature/AliasSigner'
import ContractSigner from '../accounting/signature/ContractSigner'
import ApplicationSigner from '../accounting/signature/ApplicationSigner'
import EDefterApplicationSigner from '../accounting/signature/EDefterApplicationSigner'
import SignatureValidator from '../accounting/signature/SignatureValidator'

import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import 'react-s-alert/dist/s-alert-css-effects/scale.css';
import 'react-s-alert/dist/s-alert-css-effects/genie.css';
import 'react-s-alert/dist/s-alert-css-effects/jelly.css';
import 'react-s-alert/dist/s-alert-css-effects/stackslide.css';
import 'react-accessible-accordion/dist/minimal-example.css';
import 'react-accessible-accordion/dist/fancy-example.css';

import NotificationAlert from "react-notification-alert";
import PrefixCode from "../accounting/prefixcode/PrefixCode";
import GIBUserList from "../accounting/gibuser/GIBUserList";
import CreditPoolList from "../accounting/creditpool/CreditPoolList";
import XsltList from "../accounting/customer/XsltList";
import XsltDesigner from "../accounting/customer/XsltDesigner";
import AuthRoles from "../accounting/customer/AuthRoles";
import UserList from "../accounting/user/UserList";
import QueryEnvelopeModal from "./component/QueryEnvelopeModal";
import {deepCopyObject, getEntegratorConf, hasUserRight, showAxiosError} from "../helper/helper";
import InboxWarning from "../accounting/customer/components/InboxWarning";
import CompanyProfile from "../accounting/customer/components/CompanyProfile";
import UserProfile from "../accounting/user/UserProfile";
import SidebarCustomizer from "../components/SidebarCustomizer";
import CreditList from "../accounting/credit/CreditList";
import CollectiveUserList from "../accounting/user/CollectiveUserList";
import RequestMessageList from "../accounting/requestmessage/RequestMessageList";
import HiddenVknTcknList from "../accounting/hiddenvkntckn/HiddenVknTcknList";

import TagList from "../accounting/tag/TagList";
import ProgressPaymentList from "../accounting/progresspayment/ProgressPaymentList";
import ReactLoading from "react-loading";

import GetEAInvoice from "../GetEAInvoice";
import ExcelRequest from "../accounting/excelrequest/ExcelRequest";
import BaroLogin from "../BaroLogin";
import CustomizeExcel from "../accounting/excelrequest/CustomizeExcel";
import {
	isVakifbank,
	showBaroLoginPage,
	showDistributorContract,
	showEarsivInbox,
	showFaturam24LoginPage, showKolaySmartMbt,
	showProgressPayment,
	showSidebarSgkFaturalar, showUnsignedEDefterApplication, showVatSGKDEPO, showVatStateReport
} from "../helper/permission";
import IdleTimer from 'react-idle-timer';
import CountBackModal from "./component/CountBackModal";
import UserRights from "../accounting/user/UserRights";
import CreateEditExternalCustomer from "../accounting/externalcustomer/CreateEditExternalCustomer";
import {DepoType, eCommerces, EntegratorIdentifiers, UserRightsEnum} from "../helper/enums";
import SecondaryCopyTransfer from "../accounting/secondaryCopyTransfer/SecondaryCopyTransfer";
import DocumentStatusInfo from "../accounting/documentstatus/DocumentStatusInfo";
import cacheInstance from "../components/cache/Cache";
import NewExpenseNote from "../accounting/eexpensenote/NewExpenseNote";
import BarContractCreator from "../BarContractCreator/BarContractCreator";
import SignatureInformation from "../accounting/signature/SignatureInformation";
import CustomerRequestList from "../accounting/requestform/CustomerRequestList";
import SgkAppointmentList from "../accounting/sgkappointment/SgkAppointmentList";
import VersionTrack from "../accounting/versionTrack/VersionTrack";
import ConnectorQueryExecutor from "../accounting/connector/ConnectorQueryExecutor";
import WsCustomerList from "../accounting/connector/WsCustomerList";
import ExchangeList from "../accounting/exchange/ExchangeList";
import Faturam24Sidebar from "./Faturam24Sidebar";
import Faturam24Login from "../Faturam24Login";
import Faturam24HomePage from "../Faturam24HomePage";
import ServiceDocSidebar from "../accounting/servicedocumentation/ServiceDocSidebar";
import DocumentationList from "../accounting/servicedocumentation/editdocumentations/DocumentationList";
import EndpointList from "../accounting/servicedocumentation/editdocumentations/EndpointList";
import ResponseCodeList from "../accounting/servicedocumentation/editdocumentations/ResponseCodeList";
import DocumentationDetails from "../accounting/servicedocumentation/DocumentationDetails";
import SectionDetail from "../accounting/servicedocumentation/SectionDetail";
import ReceiptList from "../accounting/ereceipt/ReceiptList";
import VersionTrackList from "../accounting/versionTrack/VersionTrackList";
import AnnouncementList from "../accounting/announcement/AnnouncementList";
import CustomerComment from "../accounting/customer/components/CustomerComment";
import MethodDetail from "../accounting/servicedocumentation/editdocumentations/MethodDetail";
import ECommerce from "../accounting/eCommerce/ECommerce";
import ResetPassword from "../accounting/user/component/ResetPassword";
import SweetAlert from 'react-bootstrap-sweetalert';
import MuhasebeciDefterBilgi from "../components/MuhasebeciDefterBilgi";
import VatStateReport from "../accounting/vatstatereport/VatStateReport";
import Timeline from "../accounting/Timeline/Timeline";
import SigortaList from "../accounting/esigorta/SigortaList";
import FinanceSealList from "../accounting/customer/components/FinanceSealList";
import SigortaTmpList from "../accounting/esigorta/SigortaTmpList";
import CreateEditSigorta from "../accounting/esigorta/CreateEditSigorta";
import SurveyList from "../accounting/survey/SurveyList";

const SmmmUserInformationList = lazy(() => import("../accounting/smmmuserinformation/SmmmUserInformationList"));
const Vuk507SeminarList = lazy(() => import("../accounting/vuk507/seminar/SeminarList"));

const SelcukIade = lazy(() => import("../accounting/invoice/component/SelcukIade"));
const HedefIade = lazy(() => import("../accounting/invoice/component/depo/iade/HedefIade"));

// voucher
const ArchiveVoucherList = lazy(() => import( "../accounting/evoucher/ArchiveVoucherList"));
const VoucherTransferList = lazy(() => import( "../accounting/evoucher/VoucherTransferList"));
const VoucherList = lazy(() => import( "../accounting/voucher/VoucherList"));
const CreateEditVoucher = lazy(() => import( "../accounting/voucher/CreateEditVoucher"));


// despatch
const EDespatchInboxList = lazy(() => import( "../accounting/edespatch/in/EDespatchInboxList"));
const EDespatchOutboxList = lazy(() => import( "../accounting/edespatch/out/EDespatchOutboxList"));
const DespatchList = lazy(() => import( "../accounting/despatch/DespatchList"));
const CreateEditDespatch = lazy(() => import( "../accounting/despatch/CreateEditDespatch"));
const EDespatchInboxTransferList = lazy(() => import('../accounting/edespatch/in/EDespatchInboxTransferList'));
const EDespatchOutboxTransferList = lazy(() => import('../accounting/edespatch/out/EDespatchOutboxTransferList'));

// defter-storage
const DefterStorageList = lazy(() => import( "../accounting/edefterstorage/DefterStorageList"));
const UploadDefterZip = lazy(() => import( "../accounting/edefterstorage/UploadDefterZip"));

// defter
const EDefterCreatePage = lazy(() => import( '../accounting/edefter/EDefterCreatePage'));
const EDefterListPage = lazy(() => import( '../accounting/edefter/EDefterListPage'));
const EDefterInformationPage = lazy(() => import( '../accounting/edefter/EDefterInformationPage'));
const EDefterApplicationPetition = lazy(() => import( '../accounting/edefter/EDefterApplicationPetition'));

// DC
const ControlPage = lazy(() => import( "../accounting/defterchecker/ControlPage"));
const EvaluationDetailPage = lazy(() => import( "../accounting/defterchecker/EvaluationDetailPage"));
const CheckerManagementPage = lazy(() => import( "../accounting/defterchecker/CheckerManagementPage"));
const CheckerDetailPage = lazy(() => import( "../accounting/defterchecker/CheckerDetailPage"));
const PartnersPage = lazy(() => import( "../accounting/defterchecker/company/PartnersPage"));
const AccountsPage = lazy(() => import( "../accounting/defterchecker/company/AccountsPage"));
const AccountPage = lazy(() => import( "../accounting/defterchecker/company/AccountPage"));
const DefterImport = lazy(() => import( '../accounting/defterchecker/DefterImport'));
const ControlListPage = lazy(() => import( '../accounting/defterchecker/ControlListPage'));

// Archive
const EArchiveReportRequest = lazy(() => import( "../accounting/earchive/EArchiveReportRequest"));
const SentReportsList = lazy(() => import( "../accounting/earchive/SentReportsList"));
const ArchiveInvoiceList = lazy(() => import('../accounting/earchive/ArchiveInvoiceList'));
const ArchiveInvoiceTransferList = lazy(() => import('../accounting/earchive/ArchiveInvoiceTransferList'));
const OKCReportList = lazy(() => import('../accounting/okcreport/OKCReportList'));
const EOKCReportList = lazy(() => import('../accounting/okcreport/EOKCReportList'));
const ExpenseNoteList = lazy(() => import('../accounting/expensenote/ExpenseNoteList'));
const CreateEditOKCReport = lazy(() => import('../accounting/okcreport/CreateEditOKCReport'));

// Invoice
const EInvoiceInboxTransferList = lazy(() => import('../accounting/einvoice/in/EInvoiceInboxTransferList'));
const EInvoiceInboxList = lazy(() => import('../accounting/einvoice/in/EInvoiceInboxList'));
const EInvoiceOutboxTransferList = lazy(() => import('../accounting/einvoice/out/EInvoiceOutboxTransferList'));
const EInvoiceOutboxList = lazy(() => import('../accounting/einvoice/out/EInvoiceOutboxList'));
const SgkInvoiceList = lazy(() => import('../accounting/einvoice/sgk/SgkInvoiceList'));
const UploadSgkInvoice = lazy(() => import('../accounting/einvoice/sgk/UploadSgkInvoice'));
const InvoiceList = lazy(() => import("../accounting/invoice/InvoiceList"));
const CreateTmpInvoice = lazy(() => import( "../accounting/invoice/CreateTmpInvoice"));
const CreateEditInvoice = lazy(() => import( "../accounting/invoice/CreateEditInvoice"));
const DepoIadeList = lazy( () => import ("../accounting/depoiade/DepoIadeList"));
const CreateEditBelge = lazy(() => import( "../accounting/ebelge/tmp/CreateEditBelge"));
const CicekSepetiOrderList = lazy(() => import( "../accounting/ciceksepeti/CicekSepetiOrderList"));
const TmpBelgeList = lazy(() => import( "../accounting/ebelge/tmp/TmpBelgeList"));
const SanalBaBsList = lazy(() => import( "../accounting/ebelge/SanalBaBsList"));
const CancelObjectBelgeList = lazy(() => import( "../accounting/ebelge/tmp/CancelObjectBelgeList"));
const VoyageDocumentList = lazy(() => import( "../accounting/voyage/VoyageDocumentList"));

const ChemistWarehousePurchaseList = lazy(() => import( "../accounting/chemistwarehouse/purchase/ChemistWarehousePurchaseList"));

class Master extends Component {

	constructor(props) {
		super(props);

		this.state = {
			currentUser: null,
			isAuthenticated: false,
			isLoading: false,
			canToggleSidebar: false,
			key: Math.random(),
			spin: "",
			queryModal: false,
			offsetWidth: null,
			showDownloadRequestTooltip: false,
			expiringContractCheckForCompanyProfile: false,
			expiringContracts: [],
			reportType: null,
			sidebarSelected: null,
			keepSessionOpen: false,
			countBackFrom: 30,
			countingBack: false,
			maxIdleTimeout: 30,
			countBackModalVisible: false,
			autoShowDefterSecondCopyNotification: true,
			initialSearchQuery: {
				query: "",
				value: "",
				active: false
			},
			passwordPayload: {
				currentPassword: null,
				newPassword: null,
				newPasswordCopy: null,
			},
			impersonate:false,
			sdEndpointId: 1,
			sdSectionId: null,
			sdDocumentationName: "",
			isSectionLoaded: null,
			isResponseCodeLoaded: null,
			serviceDocumentation: [],
			impersonateUserRoleId: null,
			entegratorConf: EntegratorConf
		};
		this.handleLogout = this.handleLogout.bind(this);
		this.loadCurrentUser = this.loadCurrentUser.bind(this);
		this.handleLogin = this.handleLogin.bind(this);
		this.reload = this.reload.bind(this);
		this.toggleQueryEnvelopeModal = this.toggleQueryEnvelopeModal.bind(this);
		this.onImpersonate = this.onImpersonate.bind(this);
		this.setOffsetWidth = this.setOffsetWidth.bind(this);
		this.updateSidebarMenus = this.updateSidebarMenus.bind(this);
		this.hasSidebarMenu = this.hasSidebarMenu.bind(this);
		this.triggerDownloadRequestTooltip = this.triggerDownloadRequestTooltip.bind(this);
		this.isEDefter = this.isEDefter.bind(this);
		this.redefineExpiringContracts = this.redefineExpiringContracts.bind(this);
		this.onSelectReport = this.onSelectReport.bind(this);
		this.idleTimer = null;
		this.onAction = this._onAction.bind(this);
		this.onActive = this._onActive.bind(this);
		this.onIdle = this._onIdle.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
		this.showModal = this.showModal.bind(this);
		this.toggleCountBackModal = this.toggleCountBackModal.bind(this);
		this.handleGoPage = this.handleGoPage.bind(this);
		this.removeSearchQuery = this.removeSearchQuery.bind(this);
		this.setPasswordPayload = this.setPasswordPayload.bind(this);
		this.onChangePasswordPayload = this.onChangePasswordPayload.bind(this);
		this.onBlurPasswordPayload = this.onBlurPasswordPayload.bind(this);
		this.passwordValidation = this.passwordValidation.bind(this);
		this.verification = this.verification.bind(this);
		this.resetPasswordFields = this.resetPasswordFields.bind(this);
	}
	setPasswordPayload(validate, e) {
		let passwordPayload = deepCopyObject(this.state.passwordPayload);
		if (validate.error) {
			this.setState({
				alert: (
					<SweetAlert warning
								title="Uyarı"
								confirmBtnText="Tamam"
								confirmBtnBsStyle="danger"
								onConfirm={() => this.setState({ alert: null })}>
						{validate.errorMessage}
					</SweetAlert>
				)
			});
		} else {
			passwordPayload[e.target.name] = e.target.value;
			this.setState({ passwordPayload });
		}
	}
	onChangePasswordPayload(e) {
		let {name,value} = e.target;
		let validate = this.passwordValidation(value,e.type,name);
		this.setPasswordPayload(validate,e);
	}
	resetPasswordFields() {
		this.setState({
			passwordPayload: {
				currentPassword: '',
				newPassword: '',
				newPasswordCopy: ''
			}
		});
	}
	onBlurPasswordPayload(e){
		let {name,value} = e.target;
		let validate = this.passwordValidation(value,e.type,name);
		this.setPasswordPayload(validate,e);
	}
	verification(password,rule,eventType){
		if(!(this.state.enablePasswordEvent))
			return false;
		if(eventType === rule.eventType || eventType === "both"){
			if(rule.type==="test"){
				if(password.length===0){
					if(rule.eventType === "blur")
						return true;
					return false;
				}

				return (!(rule.exp.test(password)));
			}
			else if(rule.type ==="search"){
				return password.search(rule.exp) === -1;
			}
			return  false;
		}
		else
			return false;
	}
	passwordValidation(password,eventType, name){
		if(name && name==='currentPassword'){
			return {
				error:false,
				errorMessage:""
			};
		}

		const rules =[
			{
				exp:/^\S*$/,
				message: "Parolada boşluk olamaz!",
				type:"test",
				eventType:"change"
			},
			{
				exp: /[!@#$%^&*(),.?":{}|<>]/,
				message: "Parola en az bir özel karakter içermelidir!",
				type: "search",
				eventType: "blur"
			},

			{
				exp:/^.{8,}$/,
				message: "Parola en az 8 karakter içermelidir!",
				type:"test",
				eventType: "blur"
			},
			{
				exp:/[0-9]/,
				message: "Parola en az bir  sayı içermelidir!",
				type:"search",
				eventType: "blur"
			},
			{
				exp:/[A-Z]/,
				message: "Parola en az bir büyük harf içermelidir!",
				type:"search",
				eventType: "blur"
			},
			{
				exp:/[a-z]/,
				message: "Parola en az bir küçük harf içermelidir!",
				type:"search",
				eventType: "blur"
			}
		]
		let passwordState = {
			error:false,
			errorMessage:""
		};
		for (const index in rules) {

			if(this.verification(password,rules[index],eventType)){
				passwordState.error=true;
				passwordState.errorMessage = rules[index].message;
				this.setState({enablePasswordEvent:false});
				if(eventType === "both")
					this.setState({enablePasswordEvent:true});
				return passwordState;
			}
		}
		return passwordState;
	}


	setServiceDocumentation = (serviceDocumentation)=>{
		this.setState({serviceDocumentation:serviceDocumentation})
	}
	getServiceDocumentation = () =>{
		return this.state.serviceDocumentation;
	}

	getAllDocWithEndpoint = () => {
		let self = this;
		let params = {
			url: "/servicedocumentation/findAllDocumentationDto",
			method: "get"
		};
		request(params)
			.then(function (response) {
				self.setServiceDocumentation(response.data);
			});
	}
	sdSidebarCallbackFunction = (endpointId) => {
		this.setState({sdEndpointId: endpointId});
	}
	sdDocumentListCallback = (sectionId, docName) => {
		this.setState({
			sdSectionId: sectionId,
			sdDocumentationName: docName,
			isSectionLoaded: true,
			isResponseCodeLoaded: true
		})
	}
	sdEndpointListCallback = (isLoaded) => {
		this.setState({isSectionLoaded: isLoaded});
	}
	sdResponseCodeListCallback = (isLoaded) => {
		this.setState({isResponseCodeLoaded: isLoaded})
	}

	updateSidebarMenus(menuList) {
		let {currentUser} = this.state;
		currentUser.sidebarMenus = menuList;
		this.setState({currentUser})
	}

	onSelectReport(reportType) {
		this.setState({reportType});
	}

	loadCurrentUser() {
		if (isAuthenticated()) {
			this.setState({
				isLoading: true,
				keepSessionOpen: localStorage.getItem(KEEP_SESSION_OPEN) === "true" ? true : false,
			});

			let {canToggleSidebar} = this.state;
			getCurrentUser()
				.then(async response => {
					let currentUser = response.data;

					const currentPath = this.props.location.pathname;
					if (currentPath.includes('/edefter/eDefterApplicationPetition')) {
						canToggleSidebar = false;
						document.body.classList.add('sidebar-mini');
					} else if (currentUser.gibApplicationRequired) {
						canToggleSidebar = false;
						document.body.classList.add('sidebar-mini');
						this.props.history.push("/signature/application");
					} else if (currentUser.gibEDefterApplicationRequired) {
						canToggleSidebar = false;
						document.body.classList.add('sidebar-mini');
						this.props.history.push("/signature/edefterApplication");
					} else if (currentUser.distributorContractSignatureRequired && showDistributorContract()) {
						canToggleSidebar = false;
						document.body.classList.add('sidebar-mini');
						this.props.history.push("/signature/distributorContract");
					} else if (currentUser.contractSignatureRequired) {
						canToggleSidebar = false;
						document.body.classList.add('sidebar-mini');
						this.props.history.push("/signature/contract");
					} else if (currentUser.aliasSignatureRequired) {
						document.body.classList.add('sidebar-mini');
						canToggleSidebar = false;
						this.props.history.push("/signature/alias");
					} else if (currentUser.hizliKvkkRequired) {
						document.body.classList.add('sidebar-mini');
						canToggleSidebar = false;
						this.props.history.push("/signature/hizliKvkk");
					} else if (currentUser.roleId && (currentUser.roleId === 5 || currentUser.roleId === 4 || currentUser.roleId === 3)) {
						currentUser.sidebarMenus['customer_actions'] === true ? this.props.history.push("/customer") :
							(currentUser.sidebarMenus['all_users'] === true ? this.props.history.push("/cUserList") :
								(currentUser.sidebarMenus['document_status'] === true ? this.props.history.push("/documentStatusInfo") :
									(currentUser.sidebarMenus['request_report'] === true ? this.props.history.push("/requestMessageList")
										: this.props.history.push("/versionTrack"))));
						canToggleSidebar = true;
					} else {
						canToggleSidebar = true;
						document.body.classList.remove('sidebar-mini');
					}

					cacheInstance.get("customerVknTckn").then(responseObject => {
						if (!responseObject) {
							cacheInstance.set("customerVknTckn", currentUser.vknTckn);
						}
					});

					this.setState({
						canToggleSidebar: canToggleSidebar,
						currentUser: currentUser,
						isAuthenticated: true,
						isLoading: false,
						impersonateUserRoleId : currentUser.impersonateUserRoleId
					});

					if (Object.keys(this.state.entegratorConf).length === 0) {
						const entegratorConf = await getEntegratorConf();
						this.setState({entegratorConf: entegratorConf})
					}
				}).catch(error => {
				this.setState({
					isLoading: false,
					currentUser: null,
					isAuthenticated: false,
				});
				this.props.history.push("/login");
			});
		} else {
			this.props.history.push("/login");
		}
	}

	componentWillMount() {
		if (!(this.checkisDocumentRouter())) {
			this.loadCurrentUser();
		}
	}

	reload(state, from) {
		if (from) {
			if (from === "header")
				this.setState({key: Math.random(), spin: "fa-spin"});
			else if (from === "sidebar") {
				this.setState({key: Math.random()});
			} else {

			}
		} else {
			if (state) {
				this.setState({spin: "fa-spin"});
			} else {
				this.setState({spin: ""});
			}
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.location.pathname !== prevProps.location.pathname) {
			window.scrollTo(0, 0)
		}
	}

	generateRandomKey() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			let r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}

	handleLogout(redirectTo = "/login", notificationType = "success", description = "You're successfully logged out.") {
		localStorage.removeItem(ACCESS_TOKEN);
		localStorage.removeItem("isActive");
		cacheInstance.flush();
		this.setState({
			currentUser: null,
			isAuthenticated: false,
			countBackModalVisible: false,
		});
		this.props.history.push(redirectTo);
	}

	handleLogin() {
		cacheInstance.flush();
		this.loadCurrentUser();
		this.props.history.push("/");
	}

	handleGoPage(route, searchQuery) {
		cacheInstance.flush();
		this.loadCurrentUser();
		cacheInstance.get("customerVknTckn").then(responseObject => {
			if (!responseObject) {
				cacheInstance.set("customerVknTckn", this.state.currentUser.vknTckn);
			}
		});
		this.setState({initialSearchQuery: searchQuery},
			this.props.history.push(route))
	}

	removeSearchQuery() {
		let initialSearchQuery = {
			query: "",
			value: "",
			active: false
		}
		this.setState({initialSearchQuery});
	}

	onImpersonate(flag) {
		if (!flag) {
			let self = this;
			let params = {
				url: '/user/exitImpersonate',
				method: "post"
			};
			request(params)
				.then(function (response) {
					let data = response.data;
					localStorage.setItem(ACCESS_TOKEN, data.accessToken);
					self.handleLogin();
				}).catch(function (error) {
				showAxiosError(error);
			});
		}
	}

	toggleQueryEnvelopeModal() {
		this.setState({queryModal: !this.state.queryModal})
	}

	toggleCountBackModal() {
		this.setState({countBackModalVisible: !this.state.countBackModalVisible})
	}

	setOffsetWidth(value) {
		this.setState({
			offsetWidth: value
		})
	}

	redefineExpiringContracts(renewedContract) {

		let expiringContracts = deepCopyObject(this.state.expiringContracts);
		let newExpiringContracts = expiringContracts.filter(ec => {
			return ec.recordId !== renewedContract.recordId;
		});

		this.setState({
			expiringContracts: newExpiringContracts
		})
	}

	handleCancel() {
		let self = this;
		self.setState({countBackModalVisible: false});
	};

	setOffsetWidth(value) {
		this.setState({offsetWidth: value})
	}

	_onAction(e) {

	}

	_onActive(e) {

	}

	_onIdle(e) {
		if (!this.state.keepSessionOpen) {
			this.showModal();
		}
	}

	async showModal() {
		let self = this;
		self.setState({
			countBackModalVisible: true,
			countingBack: true,
		});
	};

	checkisDocumentRouter() {
		let result = false;
		const checkList = [
			"/getInvoice",
			"/getEVoucher",
			"/getInboxEDespatchDocument",
			"/getOutboxEDespatchDocument",
			"/getInboxEInvoiceDocument",
			"/getOutboxEInvoiceDocument",
			"/getEReceiptDocument",
			"/getEExchangeDocument",
			"/BarContractCreator",
			"/getExpenseNoteDocument",
			"/SignatureInformation",
			"/getSigorta"
		]
		checkList.forEach(
			element => {
				if (window.location.href.includes(element))
					result = true;
			}
		)
		return result;
	}

	isCreditSufficient = (service) => {
		let poorServiceList = this.state.currentUser.poorServiceList;
		if(poorServiceList && poorServiceList.length>0){
			let found = poorServiceList.find(item=>item === service)
			if(found) return false
		}
		return true
	}

	render() {
		let siteContent = this.siteContent();
		if (this.state.isLoading)
			return <div>Sayfa yükleniyor</div>;

		return (
			<div>
				{this.state.isAuthenticated ?
					siteContent : this.checkisDocumentRouter() ?
						(
							<Switch>
								<Route path="/getInvoice/:year/:month/:uuid/:contentType"
									   render={(props) => <GetEAInvoice type="earchive" {...props} />}/>
								<Route path="/getInvoice/:year/:month/:uuid"
									   render={(props) => <GetEAInvoice type="earchive" {...props} />}/>
								<Route path="/getInvoice/:year/:uuid"
									   render={(props) => <GetEAInvoice type="earchive" {...props} />}/>
								<Route path="/getInvoice/:uuid"
									   render={(props) => <GetEAInvoice type="earchive" {...props} />}/>
								<Route path="/getInvoice"
									   render={(props) => <GetEAInvoice type="earchive" {...props} />}/>

								<Route path="/getEVoucher/:year/:month/:uuid/:contentType"
									   render={(props) => <GetEAInvoice type="voucher" {...props} />}/>
								<Route path="/getEVoucher/:year/:month/:uuid"
									   render={(props) => <GetEAInvoice type="voucher" {...props} />}/>
								<Route path="/getEVoucher/:year/:uuid"
									   render={(props) => <GetEAInvoice type="voucher" {...props} />}/>
								<Route path="/getEVoucher/:uuid"
									   render={(props) => <GetEAInvoice type="voucher" {...props} />}/>
								<Route path="/getEVoucher"
									   render={(props) => <GetEAInvoice type="voucher" {...props} />}/>

								<Route path="/getInboxEDespatchDocument/:year/:month/:uuid/:contentType"
									   render={(props) => <GetEAInvoice type="inboxDespatch" {...props} />}/>
								<Route path="/getInboxEDespatchDocument/:year/:month/:uuid"
									   render={(props) => <GetEAInvoice type="inboxDespatch" {...props} />}/>
								<Route path="/getInboxEDespatchDocument/:year/:uuid"
									   render={(props) => <GetEAInvoice type="inboxDespatch" {...props} />}/>
								<Route path="/getInboxEDespatchDocument/:uuid"
									   render={(props) => <GetEAInvoice type="inboxDespatch" {...props}/>}/>
								<Route path="/getInboxEDespatchDocument"
									   render={(props) => <GetEAInvoice type="inboxDespatch" {...props}/>}/>

								<Route path="/getOutboxEDespatchDocument/:year/:month/:uuid/:contentType"
									   render={(props) => <GetEAInvoice type="outboxDespatch" {...props} />}/>
								<Route path="/getOutboxEDespatchDocument/:year/:month/:uuid"
									   render={(props) => <GetEAInvoice type="outboxDespatch" {...props} />}/>
								<Route path="/getOutboxEDespatchDocument/:year/:uuid"
									   render={(props) => <GetEAInvoice type="outboxDespatch" {...props} />}/>
								<Route path="/getOutboxEDespatchDocument/:uuid"
									   render={(props) => <GetEAInvoice type="outboxDespatch" {...props}/>}/>
								<Route path="/getOutboxEDespatchDocument"
									   render={(props) => <GetEAInvoice type="outboxDespatch" {...props}/>}/>

								<Route path="/getInboxEInvoiceDocument/:year/:month/:uuid/:contentType"
									   render={(props) => <GetEAInvoice type="inboxInvoice" {...props} />}/>
								<Route path="/getInboxEInvoiceDocument/:year/:month/:uuid"
									   render={(props) => <GetEAInvoice type="inboxInvoice" {...props} />}/>
								<Route path="/getInboxEInvoiceDocument/:year/:uuid"
									   render={(props) => <GetEAInvoice type="inboxInvoice" {...props} />}/>
								<Route path="/getInboxEInvoiceDocument/:uuid"
									   render={(props) => <GetEAInvoice type="inboxInvoice" {...props}/>}/>
								<Route path="/getInboxEInvoiceDocument/"
									   render={(props) => <GetEAInvoice type="inboxInvoice" {...props}/>}/>

								<Route path="/getOutboxEInvoiceDocument/:year/:month/:uuid/:contentType"
									   render={(props) => <GetEAInvoice type="outboxInvoice" {...props} />}/>
								<Route path="/getOutboxEInvoiceDocument/:year/:month/:uuid"
									   render={(props) => <GetEAInvoice type="outboxInvoice" {...props} />}/>
								<Route path="/getOutboxEInvoiceDocument/:year/:uuid"
									   render={(props) => <GetEAInvoice type="outboxInvoice" {...props} />}/>
								<Route path="/getOutboxEInvoiceDocument/:uuid"
									   render={(props) => <GetEAInvoice type="outboxInvoice" {...props}/>}/>
								<Route path="/getOutboxEInvoiceDocument/"
									   render={(props) => <GetEAInvoice type="outboxInvoice" {...props}/>}/>

								<Route path="/getEReceiptDocument/:year/:month/:uuid/:contentType"
									   render={(props) => <GetEAInvoice type="receipt" {...props} />}/>
								<Route path="/getEReceiptDocument/:year/:month/:uuid"
									   render={(props) => <GetEAInvoice type="receipt" {...props} />}/>
								<Route path="/getEReceiptDocument/:year/:uuid"
									   render={(props) => <GetEAInvoice type="receipt" {...props} />}/>
								<Route path="/getEReceiptDocument/:uuid"
									   render={(props) => <GetEAInvoice type="receipt" {...props} />}/>
								<Route path="/getEReceiptDocument"
									   render={(props) => <GetEAInvoice type="receipt" {...props} />}/>

								<Route path="/getEExchangeDocument/:year/:month/:uuid/:contentType"
									   render={(props) => <GetEAInvoice type="eexchange" {...props} />}/>
								<Route path="/getEExchangeDocument/:year/:month/:uuid"
									   render={(props) => <GetEAInvoice type="eexchange" {...props} />}/>
								<Route path="/getEExchangeDocument/:year/:uuid"
									   render={(props) => <GetEAInvoice type="eexchange" {...props} />}/>
								<Route path="/getEExchangeDocument/:uuid"
									   render={(props) => <GetEAInvoice type="eexchange" {...props} />}/>
								<Route path="/getEExchangeDocument"
									   render={(props) => <GetEAInvoice type="eexchange" {...props} />}/>

								<Route path="/getExpenseNoteDocument/:year/:month/:uuid/:contentType"
									   render={(props) => <GetEAInvoice type="expenseNote" {...props} />}/>
								<Route path="/getExpenseNoteDocument/:year/:month/:uuid"
									   render={(props) => <GetEAInvoice type="expenseNote" {...props} />}/>
								<Route path="/getExpenseNoteDocument/:year/:uuid"
									   render={(props) => <GetEAInvoice type="expenseNote" {...props} />}/>
								<Route path="/getExpenseNoteDocument/:uuid"
									   render={(props) => <GetEAInvoice type="expenseNote" {...props}/>}/>
								<Route path="/getExpenseNoteDocument"
									   render={(props) => <GetEAInvoice type="expenseNote" {...props}/>}/>

								<Route path="/getSigorta/:year/:month/:uuid"
									   render={(props) => <GetEAInvoice type="esigorta" {...props} />}/>
								<Route path="/getSigorta/:year/:uuid"
									   render={(props) => <GetEAInvoice type="esigorta" {...props} />}/>
								<Route path="/getSigorta/:uuid"
									   render={(props) => <GetEAInvoice type="esigorta" {...props}/>}/>
								<Route path="/getSigorta"
									   render={(props) => <GetEAInvoice type="esigorta" {...props}/>}/>

								<Route path="/BarContractCreator/"
									   render={(props) => <BarContractCreator {...props}/>}/>
								<Route path="/SignatureInformation/"
									   render={(props) => <SignatureInformation {...props}/>}/>

							</Switch>
						) :
						(
							<Switch>
								<Route exact path="/reset-password" render={(props) =>
									<ResetPassword
										reload={this.reload}
										logOut={this.handleLogout}
										loadCurrentUser={this.loadCurrentUser}
										passwordPayload={this.state.passwordPayload}
										onChangePasswordPayload={this.onChangePasswordPayload}
										onBlurPasswordPayload={this.onBlurPasswordPayload}
										passwordValidation={this.passwordValidation}
										impersonate={this.state.impersonate}
										resetPasswordFields={this.resetPasswordFields}
										{...props}
									/>}/>
								<Route exact path="/login" render={(props) => showBaroLoginPage() ?
									<BaroLogin onLogin={this.handleLogin} {...props} /> :
									(showFaturam24LoginPage() ?
										<Faturam24Login onLogin={this.handleLogin} {...props}/> :
										<Login onLogin={this.handleLogin} {...props} />)}/>
								<Route exact path="/login/:username/:password" render={(props) =>
									<Login onLogin={this.handleLogin} {...props} />}/>
								<Route exact path="/login/:base64login" render={(props) =>
									<Login onLogin={this.handleLogin} {...props} />}/>
								<Redirect path="/" to="/login"/>
								<Route component={NotFound}></Route>
							</Switch>
						)
				}
				<NotificationAlert ref="notificationAlert"/>
				<Alert stack={{limit: 3}} html={true} offset={45}/>
			</div>

		);
	}

	isImpersonate() {
		return this.state.currentUser && this.state.currentUser.impersonate;
	}

	allowPrivateAccess() {
		return this.isEntegrator() || (this.isDistributor() && this.isAllowPrivateAccess()) || this.state.currentUser.accountant;
	}

	isEntegrator() {
		return this.state.currentUser && this.state.currentUser.entegrator;
	}

	isDistributor() {
		return this.state.currentUser && this.state.currentUser.distributor;
	}

	isAllowPrivateAccess() {
		return this.state.currentUser && this.state.currentUser.allowPrivateAccess;
	}

	isAdminUser() {
		return this.state.currentUser && this.state.currentUser.adminUser;
	}

	isCallCenter() {
		return this.state.currentUser && (this.state.currentUser.roleId === 5 || this.state.currentUser.roleId === 3);
	}

	isTeamLeader() {
		return this.state.currentUser && this.state.currentUser.roleId === 4;
	}

	isEFatura() {
		return this.state.currentUser && this.state.currentUser.holder.portal && this.state.currentUser.holder.portal.EFATURA;
	}

	isEGiderPusulasi() {
		return this.state.currentUser && this.state.currentUser.holder.portal && this.state.currentUser.holder.portal.EGIDERPUSULASI;
	}

	isEAdisyon() {
		return this.state.currentUser && this.state.currentUser.holder.portal && this.state.currentUser.holder.portal.EADISYON;
	}

	isESigorta() {
		return false && this.state.currentUser && this.state.currentUser.holder.portal && this.state.currentUser.holder.portal.ESIGORTA;
	}

	isEBelge() {
		return this.state.currentUser && this.state.currentUser.holder.portal && this.state.currentUser.holder.portal.EARSIVBESBINOTUZBIN;
	}

	isEKonnektor() {
		return this.state.currentUser && this.state.currentUser.holder.portal && this.state.currentUser.holder.portal.EKONNEKTOR;
	}

	isEIrsaliye() {
		return this.state.currentUser && this.state.currentUser.holder.portal && this.state.currentUser.holder.portal.EIRSALIYE;
	}

	isEArsiv() {
		return this.state.currentUser && this.state.currentUser.holder.portal && this.state.currentUser.holder.portal.EARSIV;
	}

	isEMM() {
		return this.state.currentUser && this.state.currentUser.holder.portal && this.state.currentUser.holder.portal.EMM;
	}

	isESMM() {
		return this.state.currentUser && this.state.currentUser.holder.portal && this.state.currentUser.holder.portal.ESMM;
	}

	isExchange() {
		return this.state.currentUser && this.state.currentUser.holder.portal && this.state.currentUser.holder.portal.EEXCHANGE;
	}

	isETicaret() {
		return this.state.currentUser && this.state.currentUser.holder.portal && this.state.currentUser.holder.portal.ETICARET;
	}

	isEDefter(privilege) {
		return this.state.currentUser && this.state.currentUser.holder.portal
			&& this.state.currentUser.holder.portal.EDEFTER &&
			(privilege === undefined ? true : this.state.currentUser.holder.portal.EDEFTER[privilege]);
	}

	isEDefterSaklama() {
		return this.state.currentUser && this.state.currentUser.holder.portal && this.state.currentUser.holder.portal.EDEFTERSAKLAMA;
	}

	isEczaciKart() {
		return this.state.currentUser && VirtualHost.conf.resourcePrefix === "eczacikart";
	}

	isDefterChecker() {
		return this.state.currentUser && this.state.currentUser.holder.accounting && this.state.currentUser.holder.accounting.DEFTERCHECKER;
	}
	isConnectorAdmin() {
		return this.state.currentUser && this.state.currentUser.connectorSqlWriter;
	}

	isEDefterBildirim(){
		return this.state.currentUser && this.state.currentUser.holder.portal && this.state.currentUser.holder.portal.EDEFTERBILDIRIM;
	}

	hasSidebarMenu(title) {
		return this.state.currentUser && this.state.currentUser.sidebarMenus && this.state.currentUser.sidebarMenus[title] === true;
	}

	decideVakifbankStyle() {
		return isVakifbank() ? {backgroundImage: "-webkit-linear-gradient(left, #f1f1f1, #efefef)"} : {}
	}

	async triggerDownloadRequestTooltip() {
		this.setState({
			showDownloadRequestTooltip: true
		});
		await this.sleep(5000);
		this.setState({
			showDownloadRequestTooltip: false
		})
	}

	sleep(ms) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}

	siteContent() {
		return (
			<React.Fragment>
				{this.state.currentUser && this.state.currentUser.roleId && this.state.currentUser.roleId !== 5 && this.state.currentUser.roleId !== 3 && this.state.currentUser.roleId !== 4 &&
				<div>
					<IdleTimer
						ref={ref => {
							this.idleTimer = ref
						}}
						element={document}
						onActive={this.onActive}
						onIdle={this.onIdle}
						onAction={this.onAction}
						debounce={250}
						timeout={1000 * 60 * this.state.maxIdleTimeout}/>
					{
						<div className="wrapper">
							<Switch currentUser={this.state.currentUser}>
								<Route path="/serviceDocumentation" render={(props) => <ServiceDocSidebar
									callback={this.sdSidebarCallbackFunction}
									currentUser={this.state.currentUser}
									canToggle={this.state.canToggleSidebar}
									serviceDocumentation = {this.state.serviceDocumentation}
									setServiceDocumentation = {this.setServiceDocumentation}
									getServiceDocumentation = {this.getServiceDocumentation}
									{...props}/>}/>
								<Route path="/" render={(props) =>
										(VirtualHost.conf.resourcePrefix === 'faturam24'|| VirtualHost.conf.resourcePrefix === 'esnaffatura') ?
										<Faturam24Sidebar isAuthenticated={this.state.isAuthenticated}
													  currentUser={this.state.currentUser}
													  canToggle={this.state.canToggleSidebar}
													  history={this.props.history}
													  reload={this.reload}
													  masterSelected={this.state.sidebarSelected}
													  resetMasterSelected={() => this.setState({sidebarSelected: null})}
													  onSelectReport={this.onSelectReport}
													  onSelectExcelReport={this.onSelectExcelReport}
													  queryEnvelopeListener={this.toggleQueryEnvelopeModal}
													  setOffsetWidth={this.setOffsetWidth}
													  entegratorConf={this.state.entegratorConf}
													  resourcePrefix={VirtualHost.conf.resourcePrefix}
										/>
										:
										<Sidebar isAuthenticated={this.state.isAuthenticated}
											 impersonateUserRoleId = {this.state.impersonateUserRoleId}
											 currentUser={this.state.currentUser}
											 canToggle={this.state.canToggleSidebar}
											 history={this.props.history}
											 reload={this.reload}
											 masterSelected={this.state.sidebarSelected}
											 resetMasterSelected={() => this.setState({sidebarSelected: null})}
											 onSelectReport={this.onSelectReport}
											 onSelectExcelReport={this.onSelectExcelReport}
											 queryEnvelopeListener={this.toggleQueryEnvelopeModal}
											 setOffsetWidth={this.setOffsetWidth}
											 resourcePrefix={VirtualHost.conf.resourcePrefix}
											 isCreditSufficient = {this.isCreditSufficient}
											 entegratorConf={this.state.entegratorConf}
											 decideVakifbankStyle={this.decideVakifbankStyle}
										/>
								}/>
								</Switch>
							<div className="main-panel">
								<Header isAuthenticated={this.state.isAuthenticated}
										currentUser={this.state.currentUser}
										impersonate={this.isImpersonate()}
										onImpersonate={this.onImpersonate}
										onLogin={this.handleLogin}
										reload={this.reload}
										spin={this.state.spin}
										location={this.props.location.pathname}
										onLogout={this.handleLogout}
										offsetWidth={this.state.offsetWidth}
										showDownloadRequestTooltip={this.state.showDownloadRequestTooltip}
										entegratorConf={this.state.entegratorConf}
								/>
								<div className=" panel-header-sm">
								</div>

								<div className="content" key={this.state.key} style={this.decideVakifbankStyle()}>
									<Suspense fallback={<ReactLoading type="spinningBubbles" style={{
										width: "70px",
										height: "70px",
										margin: "20px auto 0 auto",
										fill: "#888"
									}}/>}>
										<Switch currentUser={this.state.currentUser}>
											<Route exact path="/" render={(props) => {
												if ((VirtualHost.conf.resourcePrefix.includes('faturam24') || VirtualHost.conf.resourcePrefix === 'esnaffatura')) {
													return (
														<Faturam24HomePage
															isAuthenticated={this.state.isAuthenticated}
															currentUser={this.state.currentUser}
															isEntegrator={this.isEntegrator()}
															isDistributor={this.isDistributor()}
															{...props}/>
													)
												} else {
													return (
														<HomePage isAuthenticated={this.state.isAuthenticated}
																  impersonateUserRoleId = {this.state.impersonateUserRoleId}
																  currentUser={this.state.currentUser}
																  isEntegrator={this.isEntegrator()}
																  isDistributor={this.isDistributor()}
																  onLogout={this.handleLogout}
																  autoShowDefterSecondCopyNotification={this.state.autoShowDefterSecondCopyNotification}
																  disableAutoShowDefterSecondCopyNotification={() => this.setState({autoShowDefterSecondCopyNotification: false})}
																  enableAutoShowDefterSecondCopyNotification={() => this.setState({autoShowDefterSecondCopyNotification: true})}  {...props}
																  decideVakifbankStyle={this.decideVakifbankStyle}
																  entegratorConf={this.state.entegratorConf}
														/>
													)

												}
											}
											}
											/>

											<Route path="/homePage"
												   render={(props) => {
													    if ((VirtualHost.conf.resourcePrefix.includes('faturam24') || VirtualHost.conf.resourcePrefix === 'esnaffatura')) {
														   return (
															   <Faturam24HomePage
																   isAuthenticated={this.state.isAuthenticated}
																   currentUser={this.state.currentUser}
																   {...props}/>
														   )

													   } else {
														   return (
															   <HomePage
																   isAuthenticated={this.state.isAuthenticated}
																   impersonateUserRoleId = {this.state.impersonateUserRoleId}
																   currentUser={this.state.currentUser}
																   decideVakifbankStyle={this.decideVakifbankStyle}
																   entegratorConf={this.state.entegratorConf}
																   {...props}/>
														   )
													   }
												   }}/>

											{this.isConnectorAdmin() &&
											<Route exact path="/connector/connectorQueryExecutor"
												   render={(props) =>
													   <ConnectorQueryExecutor currentUser={this.state.currentUser} {...props}/>}/>
											}
											{this.isConnectorAdmin() &&
											<Route exact path="/connector/WsCustomerList"
												   render={(props) => <WsCustomerList {...props}/>}/>
											}
											{(this.isEntegrator() || this.isDistributor() || this.isAdminUser()) &&
											<Route path="/customizeSidebar/:customerId?"
												   render={(props) => <SidebarCustomizer
													   offsetWidth={this.state.offsetWidth}
													   updateUserHook={this.updateSidebarMenus} {...props}/>}/>
											}
											{this.isAdminUser() &&
											<Route exact path="/yetkiGruplariYonetimi"
												   render={(props) => <AuthRoles {...props}/>}/>
											}
											{(this.isEntegrator() || this.isDistributor() || this.isAdminUser()) &&
											<Route exact path="/userRights/:userId?"
												   render={(props) => <UserRights {...props}/>}/>
											}
											{(this.isAdminUser() && (this.isEArsiv() || this.isEFatura())) &&
											<Route exact path="/hiddenVknTcknList"
												   render={(props) => <HiddenVknTcknList {...props}/>}/>
											}
											<Route exact path="/xsltYonetimi"
												   render={(props) => <XsltList reload={this.reload} {...props}
																				offsetWidth={this.state.offsetWidth}
																				currentUser={this.state.currentUser}/>}/>
											<Route exact path="/xsltYonetimi/:customerId?"
												   render={(props) => <XsltList reload={this.reload} {...props}
																				offsetWidth={this.state.offsetWidth}
																				currentUser={this.state.currentUser}/>}/>
											<Route exact path="/xsltOlustur"
												   render={(props) => <XsltDesigner {...props}
																					offsetWidth={this.state.offsetWidth}
																					currentUser={this.state.currentUser}/>}/>

											<Route exact path="/customerComment"
												   render={(props) => <CustomerComment {...props}
													   								type={"Customer"}
																					currentUser={this.state.currentUser}/>}/>
											<Route exact path="/customerCommentList"
												   render={(props) => <CustomerComment {...props}
													   								type={"CallCenter"}
																					currentUser={this.state.currentUser} {...props}/>}/>

											{this.isEFatura() && showSidebarSgkFaturalar() &&
											<Route exact path="/sgkFaturalar"
												   render={(props) => <SgkInvoiceList {...props}
																					  isCreditSufficient = {this.isCreditSufficient("EFATURA")}
																					  currentUser={this.state.currentUser}/>}/>
											}

											{this.isEFatura() && showSidebarSgkFaturalar() &&
											<Route exact path="/sgkXmlYukleme"
												   render={(props) => <UploadSgkInvoice {...props}
																						currentUser={this.state.currentUser}/>}/>
											}

											{this.isEFatura() &&
											<Route exact path="/invoiceTmp" key="invoiceTmpKey"
												   render={(props) => <InvoiceList direction="Tmp"
																				   reload={this.reload}
																				   isEntegrator={this.isEntegrator()}
																				   isCreditSufficient = {this.isCreditSufficient("EFATURA")}
																				   isEczaciKart={this.isEczaciKart()}
																				   propType="fatura"
																				   profileId="EFATURA"
																				   currentUser={this.state.currentUser}
																				   name='invoiceList' {...props}/>}/>
											}

											{this.isEFatura() && this.isEczaciKart() &&
											<Route exact path="/depoIadeList"
												   render={(props) => <DepoIadeList
													   reload={this.reload}
													   isEczaciKart={this.isEczaciKart()}
													   currentUser={this.state.currentUser}
													   {...props}/>}/>

											}

											{this.isEFatura() &&
											<Route path="/eInvoiceInbox"
												   render={(props) => <EInvoiceInboxList
													   reload={this.reload} {...props}
													   isCreditSufficient = {this.isCreditSufficient("EFATURA")}
													   offsetWidth={this.state.offsetWidth}
													   name='eInvoiceInboxList'
													   triggerDownloadRequestTooltip={this.triggerDownloadRequestTooltip}
													   currentUser={this.state.currentUser}
													   resourcePrefix={VirtualHost.conf.resourcePrefix}/>}/>
											}

											{this.isEFatura() &&
											<Route path="/eInvoiceInboxTransfer"
												   render={(props) => <EInvoiceInboxTransferList
													   currentUser={this.state.currentUser}
													   isCreditSufficient = {this.isCreditSufficient("EFATURA")}
													   reload={this.reload} {...props}
													   name='eInvoiceInboxTransferList'
													   triggerDownloadRequestTooltip={this.triggerDownloadRequestTooltip}/>}/>
											}

											{((this.isEntegrator() || this.isDistributor()) && this.isAdminUser()) &&
												<Route path="/documentStatusInfo"
													   render={(props => <DocumentStatusInfo
														   impersonateUserRoleId={this.state.impersonateUserRoleId}
														   currentUser={this.state.currentUser}
														   reload={this.reload}{...props}
														   name='documentStatusInfo'
														   onImpersonate={this.onImpersonate}
														   handleGoPage={this.handleGoPage}
														   onLogin={this.handleLogin}
														   showOnDocuments={false}
													   />)}/>
											}

											{(this.isAdminUser() && showKolaySmartMbt(this.state.entegratorConf.identifier)) &&
											<Route path="/myDocumentStatusInfo"
												   render={(props => <DocumentStatusInfo
													   impersonateUserRoleId={this.state.impersonateUserRoleId}
													   currentUser={this.state.currentUser}
													   reload={this.reload}{...props}
													   name='myDocumentStatusInfo'
													   onImpersonate={this.onImpersonate}
													   handleGoPage={this.handleGoPage}
													   onLogin={this.handleLogin}
													   isEFatura={this.isEFatura()}
													   isEIrsaliye={this.isEIrsaliye()}
													   isEArsiv={this.isEArsiv()}
													   isEMM={this.isEMM()}
													   isESMM={this.isESMM()}
													   isEGiderPusulasi={this.isEGiderPusulasi()}
													   isEdefter={this.isEDefter()}
													   isEDefterBildirim={this.isEDefterBildirim()}
													   showOnDocuments={true}
												   />)}/>

											}

											{(this.state.currentUser && this.isEFatura() && showVatStateReport(this.state.entegratorConf.identifier,this.state.currentUser.parentCustomerId)) &&
												<Route path="/vatStateReport" render={(props =>
													<VatStateReport
														showSGKDepo={showVatSGKDEPO(this.state.entegratorConf.identifier,this.state.currentUser.parentCustomerId)}
														currentUser={this.state.currentUser}/>)}
													    offsetWidth={this.state.offsetWidth}
												/>
											}

											<Route path="/tagList" render={(props) => <TagList
												reload={this.reload} {...props}
												hasEFatura={this.isEFatura()}
												hasEirsaliye={this.isEIrsaliye()}
												hasEarsiv={this.isEArsiv()}
												hasEmuhtahsil={this.isEMM()}
												hasEserbestmeslek={this.isESMM()}
												hasEgiderPusulasi={this.isEGiderPusulasi()}
												hasEAdisyon={this.isEAdisyon()}
												hasESigorta={this.isESigorta()}
												hasExchange={this.isExchange()}
												currentUser={this.state.currentUser}
												name='tagList'/>}/>

											{this.isEFatura() &&
											<Route path="/eInvoiceOutbox"
												   render={(props) => <EInvoiceOutboxList
													   reload={this.reload} {...props}
													   offsetWidth={this.state.offsetWidth}
													   isCreditSufficient = {this.isCreditSufficient("EFATURA")}
													   currentUser={this.state.currentUser}
													   initialSearchQuery={this.state.initialSearchQuery}
													   removeSearchqueryProps={this.removeSearchQuery}
													   name='eInvoiceOutboxList'
													   triggerDownloadRequestTooltip={this.triggerDownloadRequestTooltip}
													   resourcePrefix={VirtualHost.conf.resourcePrefix}/>}/>
											}

											{this.isEFatura() &&
											<Route path="/eInvoiceOutboxTransfer"
												   render={(props) => <EInvoiceOutboxTransferList
													   currentUser={this.state.currentUser}
													   isCreditSufficient = {this.isCreditSufficient("EFATURA")}
													   reload={this.reload} {...props}
													   name='eInvoiceOutboxTransferList'
													   triggerDownloadRequestTooltip={this.triggerDownloadRequestTooltip}
													   impersonateUserRoleId={this.state.impersonateUserRoleId}/>}/>
											}

											{this.isEFatura() &&
											<Route path="/gibusersI"
												   render={(props) => <GIBUserList name='invoice'
																				   reload={this.reload} {...props}/>}/>
											}

											{this.isEIrsaliye() &&
											<Route path="/gibusersD"
												   render={(props) => <GIBUserList name='despatch'
																				   reload={this.reload} {...props}/>}/>
											}

											{this.isEArsiv() &&
											<Route exact path="/archiveInvoiceTmp" key="ainvoiceTmpKey"
												   render={(props) => <InvoiceList direction="Tmp"
																				   reload={this.reload}
																				   isCreditSufficient = {this.isCreditSufficient("EARSIV")}
																				   propType="earsiv"
																				   currentUser={this.state.currentUser}
																				   isEczaciKart={this.isEczaciKart()}
																				   profileId="EARSIVFATURA"
																				   name='invoiceList' {...props}/>}/>
											}


											{this.isEArsiv() &&
											<Route path="/eAInvoice"
												   render={(props) => <ArchiveInvoiceList
													   reload={this.reload} {...props}
													   name='archiveInvoiceList'
													   isCreditSufficient = {this.isCreditSufficient("EARSIV")}
													   currentUser={this.state.currentUser}
													   initialSearchQuery={this.state.initialSearchQuery}
													   removeSearchqueryProps={this.removeSearchQuery}
													   showExpenseNote={this.hasSidebarMenu("ednsm_ars_expenseNoteList")}
													   offsetWidth={this.state.offsetWidth}
													   triggerDownloadRequestTooltip={this.triggerDownloadRequestTooltip}
													   resourcePrefix={VirtualHost.conf.resourcePrefix}
													   impersonateUserRoleId={this.state.impersonateUserRoleId}/>}/>
											}

											{this.isEArsiv() &&
											<Route path="/eAInvoiceTransfer"
												   render={(props) => <ArchiveInvoiceTransferList
													   currentUser={this.state.currentUser}
													   isCreditSufficient = {this.isCreditSufficient("EARSIV")}
													   name='archiveInvoiceTransferList'
													   reload={this.reload} {...props}
													   triggerDownloadRequestTooltip={this.triggerDownloadRequestTooltip}
													   impersonateUserRoleId={this.state.impersonateUserRoleId}/>}/>
											}

											{(this.isEArsiv() || this.isESMM() || this.isEMM()) &&
											<Route path="/eArchiveReportRequest/:type"
												   render={(props) => <EArchiveReportRequest name="eArchive"
																							 isCreditSufficient = {
																								 this.props.match.type=='voucher'
																									 ? this.isCreditSufficient("EMUSTAHSIL") && this.isCreditSufficient("ESERBESTMESLEK")
																									 : this.isCreditSufficient("EARSIV")
												   											 }
																							 currentUser={this.state.currentUser}
																							 reload={this.reload} {...props}/>}/>
											}

											{(this.isEArsiv() || this.isESMM() || this.isEMM() || this.isEAdisyon() || this.isESigorta()) &&
											<Route path="/sentReportsList"
												   render={(props) => <SentReportsList name="eArchive"
																					   isCreditSufficient = {
																						   this.props.match.type=='voucher'
																							   ? this.isCreditSufficient("EMUSTAHSIL") && this.isCreditSufficient("ESERBESTMESLEK")
																							   : (this.props.match.type == 'receipt' ? this.isCreditSufficient("ERECEIPT") :
																								   (this.props.match.type == 'sigorta' ? this.isCreditSufficient("ESIGORTA") :this.isCreditSufficient("EARSIV")))
																					   }
																					   currentUser={this.state.currentUser}
																					   reload={this.reload} {...props}
																					   reportType={this.state.reportType}/>}/>
											}

											{this.isEArsiv() &&
											<Route path="/okcReportList"
												   render={(props) => <OKCReportList reload={this.reload}
																					 isCreditSufficient = {this.isCreditSufficient("EARSIV") && this.isCreditSufficient("MRAPOR")}
																					 currentUser={this.state.currentUser} {...props}/>}/>
											}

											{this.isEArsiv() &&
											<Route path="/okcReports"
												   render={(props) => <EOKCReportList reload={this.reload}
																					  isCreditSufficient = {this.isCreditSufficient("EARSIV") && this.isCreditSufficient("YMRAPOR")}
																					  currentUser={this.state.currentUser} {...props}/>}/>
											}

											{this.isEArsiv() &&
											<Route path="/expenseNoteList"
												   render={(props) => <ExpenseNoteList reload={this.reload}
																					   isCreditSufficient = {this.isCreditSufficient("EARSIV")}
																					   currentUser={this.state.currentUser} {...props}/>}/>
											}

											{(this.isEArsiv() && hasUserRight([UserRightsEnum.okc.createReport, UserRightsEnum.okc.editReport], this.state.currentUser)) &&
											<Route path="/okcReport/edit/:recordId"
												   render={(props) => <CreateEditOKCReport {...props}
																						   currentUser={this.state.currentUser}
																						   offsetWidth={this.state.offsetWidth}/>}/>
											}

											{(((this.isEArsiv() && hasUserRight([UserRightsEnum.earchive.update, UserRightsEnum.earchive.create], this.state.currentUser))) ||
												((this.isEFatura() && hasUserRight([UserRightsEnum.invoice.update, UserRightsEnum.invoice.create], this.state.currentUser)))) &&
											<Route path="/createEditInvoice/:direction/:recordId/:type"
												   render={(props) => <CreateEditInvoice {...props}
																						 isCreditSufficient = {(this.isEArsiv() && this.isCreditSufficient("EARSIV")) || (this.isEFatura() && this.isCreditSufficient("EFATURA"))}
																						 currentUser={this.state.currentUser}
																						 offsetWidth={this.state.offsetWidth}/>}/>
											}
											{(((this.isEArsiv() && hasUserRight(UserRightsEnum.earchive.create, this.state.currentUser))) ||
												((this.isEFatura() && hasUserRight(UserRightsEnum.invoice.create, this.state.currentUser)))) &&
											<Route path="/invoice/create"
												   render={(props) => <CreateTmpInvoice {...props}
																						isCreditSufficient = {(this.isEArsiv() && this.isCreditSufficient("EARSIV")) || (this.isEFatura() && this.isCreditSufficient("EFATURA"))}
																						currentUser={this.state.currentUser}
																						offsetWidth={this.state.offsetWidth}/>}/>
											}
											{(this.isEArsiv() || this.isEFatura()) &&
											<Route path="/invoice/iade/selcuk"
												   render={(props) => <SelcukIade {...props}
																				  depoType={DepoType.SELCUK}
																				  offsetWidth={this.state.offsetWidth}/>}/>
											}
											{(this.isEArsiv() || this.isEFatura()) &&
											<Route path="/invoice/iade/nevzat"
												   render={(props) => <SelcukIade {...props}
																				  depoType={DepoType.NEVZAT}
																				  offsetWidth={this.state.offsetWidth}/>}/>
											}
											{(this.isEArsiv() || this.isEFatura()) &&
											<Route path="/invoice/iade/as-ecza"
												   render={(props) => <SelcukIade {...props}
																				  depoType={DepoType.AS}
																				  offsetWidth={this.state.offsetWidth}/>}/>
											}
											{(this.isEArsiv() || this.isEFatura()) &&
											<Route path="/invoice/iade/imaj"
												   render={(props) => <SelcukIade {...props}
																				  depoType={DepoType.IMAJ}
																				  offsetWidth={this.state.offsetWidth}/>}/>
											}
											{(this.isEArsiv() || this.isEFatura()) &&
											<Route path="/invoice/iade/hedef"
												   render={(props) => <HedefIade {...props}
																				 depoType={DepoType.HEDEF_ALLIANCE}
																				 offsetWidth={this.state.offsetWidth}/>}/>
											}
											{(this.isEArsiv() || this.isEFatura()) &&
												<Route path="/invoice/iade/sancak"
													   render={(props) => <HedefIade {...props}
																					 depoType={DepoType.SANCAK}
																					 offsetWidth={this.state.offsetWidth}/>}/>
											}
											{(this.isEArsiv() || this.isEFatura()) &&
											<Route path="/invoice/iade/afyon"
												   render={(props) => <SelcukIade {...props}
																				  depoType={DepoType.AFYON}
																				  offsetWidth={this.state.offsetWidth}/>}/>
											}
											{(this.isEArsiv() || this.isEFatura()) &&
											<Route path="/invoice/iade/denge"
												   render={(props) => <SelcukIade {...props}
																				  depoType={DepoType.DENGE}
																				  offsetWidth={this.state.offsetWidth}/>}/>
											}
											{(this.isEArsiv() || this.isEFatura()) &&
											<Route path="/invoice/iade/maden-ecza"
												   render={(props) => <SelcukIade {...props}
																				  depoType={DepoType.MADEN}
																				  offsetWidth={this.state.offsetWidth}/>}/>
											}
											{(this.isEArsiv() || this.isEFatura()) &&
											<Route path="/invoice/iade/kizilay-ecza"
												   render={(props) => <SelcukIade {...props}
																				  depoType={DepoType.KIZILAY}
																				  offsetWidth={this.state.offsetWidth}/>}/>
											}

											{this.isEIrsaliye() &&
											<Route path="/eDespatchInbox"
												   render={(props) => <EDespatchInboxList
													   reload={this.reload} {...props}
													   isCreditSufficient = {this.isCreditSufficient("EIRSALIYE")}
													   offsetWidth={this.state.offsetWidth}
													   name='eDespatchInboxList'
													   currentUser={this.state.currentUser}
													   triggerDownloadRequestTooltip={this.triggerDownloadRequestTooltip}
													   impersonateUserRoleId={this.state.impersonateUserRoleId}/>}/>
											}
											{this.isEIrsaliye() &&
											<Route path="/eDespatchOutbox"
												   render={(props) => <EDespatchOutboxList
													   reload={this.reload} {...props}
													   isCreditSufficient = {this.isCreditSufficient("EIRSALIYE")}
													   offsetWidth={this.state.offsetWidth}
													   initialSearchQuery={this.state.initialSearchQuery}
													   removeSearchqueryProps={this.removeSearchQuery}
													   name='eDespatchOutboxList'
													   currentUser={this.state.currentUser}
													   triggerDownloadRequestTooltip={this.triggerDownloadRequestTooltip}
													   resourcePrefix={VirtualHost.conf.resourcePrefix}
													   impersonateUserRoleId={this.state.impersonateUserRoleId}/>}/>
											}

											{this.isEIrsaliye() &&
											<Route path="/eDespatchOutboxTransfer"
												   render={(props) => <EDespatchOutboxTransferList
													   isCreditSufficient = {this.isCreditSufficient("EIRSALIYE")}
													   reload={this.reload} {...props}
													   name='eDespatchOutboxTransferList'
													   currentUser={this.state.currentUser}
													   triggerDownloadRequestTooltip={this.triggerDownloadRequestTooltip}/>}/>
											}

											{this.isEIrsaliye() &&
											<Route path="/eDespatchInboxTransfer"
												   render={(props) => <EDespatchInboxTransferList
													   reload={this.reload} {...props}
													   isCreditSufficient = {this.isCreditSufficient("EIRSALIYE")}
													   name='eDespatchInboxTransferList'
													   currentUser={this.state.currentUser}
													   triggerDownloadRequestTooltip={this.triggerDownloadRequestTooltip}
													   impersonateUserRoleId={this.state.impersonateUserRoleId}/>}/>
											}

											{this.isEMM() &&
											<Route path="/eVoucherM" key="eVoucherMKey"
												   render={(props) => <ArchiveVoucherList reload={this.reload}
																						  currentUser={this.state.currentUser}
																						  isCreditSufficient = {this.isCreditSufficient("EMUSTAHSIL")}
																						  documentType="MUSTAHSILMAKBUZ" {...props}
																						  initialSearchQuery={this.state.initialSearchQuery}
																						  removeSearchqueryProps={this.removeSearchQuery}
																						  offsetWidth={this.state.offsetWidth}
																						  name='archiveVoucher'
																						  triggerDownloadRequestTooltip={this.triggerDownloadRequestTooltip}
																						  resourcePrefix={VirtualHost.conf.resourcePrefix}
																						  impersonateUserRoleId={this.state.impersonateUserRoleId}/>}/>
											}

											{this.isEMM() &&
											<Route path="/eVoucherMT" key="eVoucherMTKey"
												   render={(props) => <VoucherList type="MM" direction="Tmp"
																				   isEntegrator={this.isEntegrator()}
																				   isCreditSufficient = {this.isCreditSufficient("EMUSTAHSIL")}
																				   currentUser={this.state.currentUser}
																				   reload={this.reload} {...props}
																				   name='voucherList'
																				   triggerDownloadRequestTooltip={this.triggerDownloadRequestTooltip}/>}/>
											}

											{this.isESMM() &&
											<Route path="/eVoucherS" key="eVoucherSKey"
												   render={(props) => <ArchiveVoucherList reload={this.reload}
																						  currentUser={this.state.currentUser}
																						  isCreditSufficient = {this.isCreditSufficient("ESERBESTMESLEK")}
																						  documentType="SERBESTMESLEKMAKBUZ" {...props}
																						  initialSearchQuery={this.state.initialSearchQuery}
																						  removeSearchqueryProps={this.removeSearchQuery}
																						  offsetWidth={this.state.offsetWidth}
																						  name='archiveVoucher'
																						  triggerDownloadRequestTooltip={this.triggerDownloadRequestTooltip}
																						  resourcePrefix={VirtualHost.conf.resourcePrefix}/>}/>
											}

											{this.isESMM() &&
											<Route path="/eVoucherST" key="eVoucherSTKey"
												   render={(props) => <VoucherList type="SMM" direction="Tmp"
																				   isCreditSufficient = {this.isCreditSufficient("ESERBESTMESLEK")}
																				   currentUser={this.state.currentUser}
																				   reload={this.reload} {...props}
																				   name='voucherList'
																				   triggerDownloadRequestTooltip={this.triggerDownloadRequestTooltip}/>}/>
											}

											{this.isESMM() &&
											<Route path="/eVoucherSTransfer"
												   render={(props) => <VoucherTransferList
													   currentUser={this.state.currentUser}
													   isCreditSufficient = {this.isCreditSufficient("ESERBESTMESLEK")}
													   name='VoucherTransferList'
													   documentType="SERBESTMESLEKMAKBUZ"
													   reload={this.reload} {...props}
													   triggerDownloadRequestTooltip={this.triggerDownloadRequestTooltip}
													   impersonateUserRoleId={this.state.impersonateUserRoleId}/>}/>
											}

											{this.isEMM() &&
											<Route path="/eVoucherMTransfer"
												   render={(props) => <VoucherTransferList
													   currentUser={this.state.currentUser}
													   isCreditSufficient = {this.isCreditSufficient("EMUSTAHSIL")}
													   name='VoucherTransferList'
													   documentType="MUSTAHSILMAKBUZ"
													   reload={this.reload} {...props}
													   triggerDownloadRequestTooltip={this.triggerDownloadRequestTooltip}
													   impersonateUserRoleId={this.state.impersonateUserRoleId}/>}/>
											}

											{this.isExchange() &&
											<Route path="/eVoucherET" key="eVoucherETKey"
												   render={(props) => <VoucherList type="EXCHANGE" direction="Tmp"
																				   currentUser={this.state.currentUser}
																				   reload={this.reload} {...props}
																				   isCreditSufficient = {this.isCreditSufficient("EEXCHANGE")}
																				   name='voucherList'
																				   triggerDownloadRequestTooltip={this.triggerDownloadRequestTooltip}/>}/>
											}

											{this.isExchange() &&
											<Route path="/exchangeList" key="exchangeListKey"
												   render={(props) => <ExchangeList reload={this.reload}
																					currentUser={this.state.currentUser}
																					isCreditSufficient = {this.isCreditSufficient("EEXCHANGE")}
																					{...props}
																					initialSearchQuery={this.state.initialSearchQuery}
																					removeSearchqueryProps={this.removeSearchQuery}
																					offsetWidth={this.state.offsetWidth}
																					triggerDownloadRequestTooltip={this.triggerDownloadRequestTooltip}
																					resourcePrefix={VirtualHost.conf.resourcePrefix}
																					impersonateUserRoleId={this.state.impersonateUserRoleId}/>}/>
											}

											{(((this.isESMM() && hasUserRight([UserRightsEnum.voucher.smmCreate, UserRightsEnum.voucher.smmUpdate], this.state.currentUser))) ||
												((this.isEMM() && hasUserRight([UserRightsEnum.voucher.mmCreate, UserRightsEnum.voucher.mmUpdate], this.state.currentUser))) ||
												((this.isExchange() && hasUserRight([UserRightsEnum.exchange.create, UserRightsEnum.exchange.update], this.state.currentUser)))) &&
											<Route path="/createEditVoucher/:type/:direction/:recordId"
												   render={(props) => <CreateEditVoucher {...props}
																						 currentUser={this.state.currentUser}
																						 resourcePrefix={VirtualHost.conf.resourcePrefix}
																						 offsetWidth={this.state.offsetWidth}/>}/>
											}

											{this.isEDefterSaklama() &&
											<Route exact path="/yuklenenDefterler"
												   render={(props) => <DefterStorageList
													   reload={this.reload} {...props} />}/>
											}

											{this.isEDefterSaklama() &&
											<Route exact path="/edefterZipYukleme"
												   render={(props) => <UploadDefterZip {...props} isCreditSufficient = {this.isCreditSufficient("EDEFTERSAKLAMA")} />}/>
											}

											<Route exact path="/customizeExcel"
												   render={(props) => <CustomizeExcel reload={this.reload}
																					  name="excelRequest"
																					  offsetWidth={this.state.offsetWidth}
																					  currentUser={this.state.currentUser} {...props} />}/>

											<Route exact path="/excelRequest"
												   render={(props) => <ExcelRequest reload={this.reload}
																					name="excelRequest"
																					isCreditSufficient = {
													   									this.isCreditSufficient("EEXCHANGE") &&
													   									this.isCreditSufficient("SAKLAMA") &&
													   									this.isCreditSufficient("ERECEIPT") &&
													   									this.isCreditSufficient("EIRSALIYE") &&
													   									this.isCreditSufficient("EGIDERPUSULASI") &&
													   									this.isCreditSufficient("EARSIV") &&
													   									this.isCreditSufficient("EMUSTAHSIL") &&
													   									this.isCreditSufficient("ESERBESTMESLEK") &&
													   									this.isCreditSufficient("EIRSALIYE") &&
													   									this.isCreditSufficient("YMRAPOR") &&
													   									this.isCreditSufficient("MRAPOR") &&
													   									this.isCreditSufficient("EFATURA")
												   									}
																					hasLine={false}
																					offsetWidth={this.state.offsetWidth}
																					currentUser={this.state.currentUser} {...props} />}/>
											<Route exact path="/excelRequestWithLine"
												   render={(props) => <ExcelRequest reload={this.reload}
																					name="excelRequestWithLine"
																					offsetWidth={this.state.offsetWidth}
																					isCreditSufficient = {
																						this.isCreditSufficient("EEXCHANGE") &&
																						this.isCreditSufficient("SAKLAMA") &&
																						this.isCreditSufficient("ERECEIPT") &&
																						this.isCreditSufficient("EIRSALIYE") &&
																						this.isCreditSufficient("EGIDERPUSULASI") &&
																						this.isCreditSufficient("EARSIV") &&
																						this.isCreditSufficient("EMUSTAHSIL") &&
																						this.isCreditSufficient("ESERBESTMESLEK") &&
																						this.isCreditSufficient("EIRSALIYE") &&
																						this.isCreditSufficient("YMRAPOR") &&
																						this.isCreditSufficient("MRAPOR") &&
																						this.isCreditSufficient("EFATURA")
																					}
																					hasLine={true}
																					currentUser={this.state.currentUser} {...props} />}/>
											{this.isEczaciKart() &&
												<Route exact path="/excelRequestForSgkCiro"
													   render={(props) => <ExcelRequest reload={this.reload}
																						name="excelRequestForSgkCiro"
																						offsetWidth={this.state.offsetWidth}
																						isCreditSufficient={
																							this.isCreditSufficient("EEXCHANGE") &&
																							this.isCreditSufficient("SAKLAMA") &&
																							this.isCreditSufficient("ERECEIPT") &&
																							this.isCreditSufficient("EIRSALIYE") &&
																							this.isCreditSufficient("EGIDERPUSULASI") &&
																							this.isCreditSufficient("EARSIV") &&
																							this.isCreditSufficient("EMUSTAHSIL") &&
																							this.isCreditSufficient("ESERBESTMESLEK") &&
																							this.isCreditSufficient("EIRSALIYE") &&
																							this.isCreditSufficient("YMRAPOR") &&
																							this.isCreditSufficient("MRAPOR") &&
																							this.isCreditSufficient("EFATURA")
																						}
																						hasLine={false}
																						currentUser={this.state.currentUser}
																						sgkCiroReport={true}
																						{...props} />}/>}

											<Route path="/despatch/:type/:recordId?"
												   render={(props) => <CreateEditDespatch {...props}
																						  currentUser={this.state.currentUser}
																						  offsetWidth={this.state.offsetWidth}/>}/>
											<Route exact path="/despatch" key="despatchKey"
												   render={(props) => <DespatchList name="despatches"
																					isEntegrator={this.isEntegrator()}
																					isCreditSufficient = {this.isCreditSufficient("EIRSALIYE")}
																					currentUser={this.state.currentUser}
																					profileId="TEMELIRSALIYE"
																					reload={this.reload} {...props}/>}/>
											<Route exact path="/stockCard" key="stockCardKey"
												   render={(props) => <StockList reload={this.reload}
																				 currentUser={this.state.currentUser} {...props}/>}/>

											<Route exact path="/externalCustomer" key="externalCustomerList"
												   render={(props) => <ExternalCustomerList
													   impersonateUserRoleId={this.state.impersonateUserRoleId}
													   name="externalCustomers"
													   currentUser={this.state.currentUser} {...props}/>}/>

											<Route path="/createEditExternalCustomer/:type/:recordId"
												   render={(props) => <CreateEditExternalCustomer
													   currentUser={this.state.currentUser}
													   name="createEditExternalCustomer" {...props}/>}/>

											{(((this.isEntegrator() || this.isDistributor()) && this.isAdminUser()) ||
												(this.state.currentUser && this.state.currentUser.accountant) &&
												this.state.currentUser.sidebarMenus['customer_actions'] === true) &&
											<Route exact path="/customer" key="customerList"
												   render={(props) => <CustomerList name="customer"
																					impersonateUserRoleId={this.state.impersonateUserRoleId}
																					reload={this.reload}
																					onImpersonate={this.onImpersonate}
																					allowPrivateAccess={this.allowPrivateAccess()}
																					isEntegrator={this.isEntegrator()}
																					isDistributor={this.isDistributor()}
																					currentUser={this.state.currentUser}
																					isAdmin={this.isAdminUser()}
																					onLogin={this.handleLogin} {...props}
																					triggerDownloadRequestTooltip={this.triggerDownloadRequestTooltip}/>}/>
											}
											<Route exact path="/muhasebeDefter" key="muhasebeDefter"
												   render={(props) => <MuhasebeciDefterBilgi name="muhasebeDefter"
																							 impersonateUserRoleId={this.state.impersonateUserRoleId}
																							 reload={this.reload}
																							 currentUser={this.state.currentUser} {...props}
																							 soapUrl={this.state.currentUser.edefterSoapUrl}
																							 isCreditSufficient={this.isCreditSufficient("EDEFTER")}
																							 profileId="MuhasebeDefterBilgi"

												   />}
											/>
											<Route
												exact
												path="/progresspayment"
												key="progresspayment"
												render={(props) => {
													const firstCondition =
														(this.isEntegrator() || this.isDistributor()) &&
														this.isAdminUser() &&
														showProgressPayment(this.state.currentUser.customerId);

													const secondCondition =
														this.isDistributor() &&
														(
															EntegratorIdentifiers.SMART === this.state.entegratorConf?.identifier
														) &&
														this.state.currentUser.workType === 1

													const isActive = firstCondition ? false : secondCondition;

													return (
														<ProgressPaymentList
															currentUser={this.state.currentUser}
															reload={this.reload}
															{...props}
															impersonateUserRoleId={this.state.impersonateUserRoleId}
															isActive={isActive}
														/>
													);
												}}
											/>
											{(VirtualHost.conf.resourcePrefix === "kolaysoft" && this.isEntegrator() && this.isAdminUser()) &&
											<Route exact path="/smmmUsers" key="smmmUserInformation"
												   render={(props) => <SmmmUserInformationList
													   // currentUser={this.state.currentUser}
													   reload={this.reload} {...props}/>}/>
											}

											{(EntegratorIdentifiers.KOLAYSOFT === this.state.entegratorConf.identifier && this.isEntegrator() && this.isAdminUser()) &&
											<Route exact path="/seminarList" key="seminarList"
												   render={(props) => <Vuk507SeminarList
													   reload={this.reload} {...props}/>}/>
											}

											{((this.isEntegrator() || this.isDistributor()) && this.isAdminUser()) &&
											<Route exact path="/creditList" key="creditList"
												   render={(props) => <CreditList name="creditList"
																				  impersonateUserRoleId={this.state.impersonateUserRoleId}
																				  reload={this.reload}
																				  currentUser={this.state.currentUser} {...props}/>}/>
											}
											{((((this.isEntegrator() || this.isDistributor()) && this.isAdminUser()) || this.isTeamLeader()) || this.isCallCenter()) &&
											<Route exact path="/requestMessageList" key="requestMessageList"
												   render={(props) => <RequestMessageList name="requestMessageList"
																						  impersonateUserRoleId={this.state.impersonateUserRoleId}
																						  isEntegrator={this.isEntegrator()}
																						  currentUser={this.state.currentUser}
																						  offsetWidth={this.state.offsetWidth}
																						  onImpersonate={this.onImpersonate}
																						  onLogin={this.handleLogin} {...props}
																						  allowPrivateAccess={this.allowPrivateAccess()}
																						  reload={this.reload} {...props}/>}/>
											}
											{(VirtualHost.conf.resourcePrefix === "kolaysoft" && this.isEntegrator() && this.hasSidebarMenu("ednsm_settings_sgkRanList")) &&
											<Route exact path="/sgkAppointmentList" key="sgkAppointmentList"
												   render={(props) =>
													   <SgkAppointmentList name="sgkAppointmentList"
																		   impersonateUserRoleId={this.state.impersonateUserRoleId}
																		   currentUser={this.state.currentUser}
																		   onImpersonate={this.onImpersonate}
																		   onLogin={this.handleLogin} {...props}
																		   reload={this.reload} {...props}/>}/>
											}
											{(this.isEntegrator() || this.isDistributor()) &&
											<Route exact path="/customerRequestList" key="customerRequestList"
												   render={(props) => <CustomerRequestList name="customerRequestList"
																						   currentUser={this.state.currentUser}
																						   isEntegrator={this.isEntegrator()}
																						   offsetWidth={this.state.offsetWidth}
																						   onImpersonate={this.onImpersonate}
																						   onLogin={this.handleLogin} {...props}
																						   allowPrivateAccess={this.allowPrivateAccess()}
																						   reload={this.reload} {...props}/>}/>
											}

											<Route exact path="/versionTrack" key="versionTrack"
												   render={(props) => <VersionTrack
													   name="versionTrack"
													   currentUser={this.state.currentUser}
													   isEntegrator={this.isEntegrator()}
													   offsetWidth={this.state.offsetWidth}
													   onImpersonate={this.onImpersonate}
													   onLogin={this.handleLogin} {...props}
													   allowPrivateAccess={this.allowPrivateAccess()}
													   reload={this.reload} {...props}/>}/>


											<Route exact path="/versionTrackList" key="versionTrackList"
												   render={(props) => <VersionTrackList
													   name="versionTrackList"
													   currentUser={this.state.currentUser}
													   isEntegrator={this.isEntegrator()}
													   offsetWidth={this.state.offsetWidth}
													   onImpersonate={this.onImpersonate}
													   onLogin={this.handleLogin} {...props}
													   allowPrivateAccess={this.allowPrivateAccess()}
													   reload={this.reload} {...props}/>}/>

											<Route exact path="/announcementList" key="announcementList"
												   render={(props) => <AnnouncementList
													   name="announcementList"
													   currentUser={this.state.currentUser}
													   isEntegrator={this.isEntegrator()}
													   offsetWidth={this.state.offsetWidth}
													   onImpersonate={this.onImpersonate}
													   onLogin={this.handleLogin} {...props}
													   allowPrivateAccess={this.allowPrivateAccess()}
													   reload={this.reload} {...props}/>}/>

											<Route exact path="/surveyList" key="surveyList"
												   render={(props) => <SurveyList
													   name="surveyList"
													   currentUser={this.state.currentUser}
													   isEntegrator={this.isEntegrator()}
													   offsetWidth={this.state.offsetWidth}
													   onImpersonate={this.onImpersonate}
													   onLogin={this.handleLogin} {...props}
													   allowPrivateAccess={this.allowPrivateAccess()}
													   reload={this.reload} {...props}/>}/>

											{((this.isEntegrator() || this.isDistributor()) && this.isAdminUser()) &&
											<Route path="/createEditCustomer/:recordId"
												   render={(props) => <CreateEditCustomer name="createEditCustomer"
																						  impersonateUserRoleId={this.state.impersonateUserRoleId}
																						  loadCurrentUser={this.loadCurrentUser}
																						  currentUser={this.state.currentUser}
																						  isEntegrator={this.isEntegrator()}
																						  isAdminUser={this.isAdminUser()}
																						  isDistributor={this.isDistributor()}
																						  reload={this.reload} {...props}/>}/>
											}

											{this.isAdminUser() &&
											<Route path="/companyProfile/:recordId"
												   render={(props) => <CompanyProfile name="companyProfile"
																					  companyProfile={true}
																					  isAdminUser={this.isAdminUser()}
																					  isEntegrator={this.isEntegrator()}
																					  isDistributor={this.isDistributor()}
																					  currentUser={this.state.currentUser}
																					  loadCurrentUser={this.loadCurrentUser}
																					  expiringContracts={this.state.expiringContracts}
																					  redefineExpiringContracts={this.redefineExpiringContracts}
																					  reload={this.reload} {...props}
																					  isEKonnektor={this.isEKonnektor()}
																					  isEArsiv={this.isEArsiv()}
																					  isEFatura={this.isEFatura()}
																					  isEbelge={this.isEBelge()}/>}/>
											}

											{this.isAdminUser() &&
											<Route path="/userList" key="userList"
												   render={(props) => <UserList name="userList"
																				impersonateUserRoleId={this.state.impersonateUserRoleId}
																				currentUser={this.state.currentUser}
																				isEntegrator={this.isEntegrator()}
																				reload={this.reload} {...props}/>}/>
											}

											<Route path="/userProfile" key="userProfile"
												   render={(props) => <UserProfile name="userProfile"
																				   impersonateUserRoleId={this.state.impersonateUserRoleId}
																				   currentUser={this.state.currentUser}
																				   reload={this.reload}
																				   logOut={this.handleLogout}
																				   loadCurrentUser={this.loadCurrentUser}
																				   isEntegrator={this.isEntegrator()}
																				   isDistributor={this.isDistributor()}
																				   isAdminUser={this.isAdminUser()}
																				   impersonate={this.state.currentUser.impersonate} {...props}
												   />}/>

											<Route path="/inboxWarning" key="inboxWarning"
												   render={(props) => <InboxWarning name="inboxWarning"
																					currentUser={this.state.currentUser}
																					selectedCustomer={this.state.currentUser}
																					reload={this.reload}
																					side={true} {...props}/>}/>

											{((this.isEntegrator() || this.isDistributor()) && this.isAdminUser()) &&
											<Route exact path="/creditPoolList"
												   render={(props) => <CreditPoolList
													   reload={this.reload} {...props} />}/>
											}

											<Route exact path="/prefixCode" key="prefixCode"
												   render={(props) => <PrefixCode name="prefixCode"
																				  currentUser={this.state.currentUser}
																				  reload={this.reload} {...props}/>}/>
											<Route exact path="/secondaryCopyTransfer" key="secondaryCopyTransfer"
												   render={(props) => <SecondaryCopyTransfer
													   name="secondaryCopyTransfer"
													   currentUser={this.state.currentUser}
													   reload={this.reload} {...props}/>}/>
											{((this.isEntegrator() || this.isDistributor()) && this.isAdminUser()) &&
											<Route exact path="/cUserList" key="cUserList"
												   render={(props) => <CollectiveUserList name="cUserList"
																						  impersonateUserRoleId={this.state.impersonateUserRoleId}
																						  currentUser={this.state.currentUser}
																						  reload={this.reload}
																						  isAdmin={this.isAdminUser()}
																						  onLogin={this.handleLogin}
																						  onImpersonate={this.onImpersonate}
																						  allowPrivateAccess={this.allowPrivateAccess()}
																						  {...props}/>}/>}

											{this.state.currentUser.hasDistributorSealAuthority &&
												<Route exact path="/financeSealList" key="financeSealList"
													   render={(props) => <FinanceSealList name="financeSealList"
																						   impersonateUserRoleId={this.state.impersonateUserRoleId}
																						   currentUser={this.state.currentUser}
																						   offsetWidth={this.state.offsetWidth}
																						   reload={this.reload}
																						   isAdmin={this.isAdminUser()}
																						   onLogin={this.handleLogin}
																						   onImpersonate={this.onImpersonate}
																						   allowPrivateAccess={this.allowPrivateAccess()}
																						   {...props}/>}/>
											}

											{this.isDefterChecker() &&
											<Route exact path="/defterchecker/defterimportwizard"
												   render={(props) => <DefterImport {...props}
																					currentUser={this.state.currentUser}/>}/>}
											{this.isDefterChecker() && <Route exact path="/defterchecker/periodlist"
																			  render={(props) =>
																				  <ControlListPage {...props} />}/>}
											{this.isDefterChecker() &&
											<Route exact path="/defterchecker/management/checker/:id"
												   render={(props) => <CheckerDetailPage {...props} />}/>}
											{this.isDefterChecker() &&
											<Route exact path="/defterchecker/management"
												   render={(props) => <CheckerManagementPage {...props} />}/>}
											{this.isDefterChecker() &&
											<Route exact path="/defterchecker/control/:id"
												   render={(props) =>
													   <ControlPage {...props} />}/>}
											{this.isDefterChecker() &&
											<Route path="/defterchecker/evaluation/:id"
												   render={(props) => <EvaluationDetailPage {...props} />}/>}
											{this.isDefterChecker() &&
											<Route path="/defterchecker/company/account/:id"
												   render={(props) =>
													   <AccountPage {...props} />}/>}
											{this.isDefterChecker() &&
											<Route path="/defterchecker/company/accounts"
												   render={(props) => <AccountsPage
													   offsetWidth={this.state.offsetWidth}
													   {...props} />}/>}
											{this.isDefterChecker() && <Route path="/defterchecker/company/partners"
																			  render={(props) =>
																				  <PartnersPage {...props} />}/>}

											<Route exact path="/signature/alias" render={(props) => <AliasSigner
												currentUser={this.state.currentUser} {...props} />}/>
											<Route exact path="/signature/contract"
												   render={(props) => <ContractSigner
													   currentUser={this.state.currentUser}
													   type="service" key="service"
													   onLogout={this.handleLogout} {...props} />}/>
											<Route exact path="/signature/hizliKvkk"
												   render={(props) => <ContractSigner
													   currentUser={this.state.currentUser}
													   type="hizliKvkk" key="hizliKvkk"
													   onLogout={this.handleLogout} {...props} />}/>
											<Route exact path="/signature/distributorContract"
												   render={(props) => <ContractSigner
													   currentUser={this.state.currentUser}
													   type="distributor" key="distributor"
													   onLogout={this.handleLogout} {...props} />}/>

											<Route exact path="/signature/application"
												   render={(props) => <ApplicationSigner
													   currentUser={this.state.currentUser} {...props} />}/>
											<Route exact path="/signature/edefterApplication"
												   render={(props) => <EDefterApplicationSigner
													   currentUser={this.state.currentUser}
													   unsignedApplication={showUnsignedEDefterApplication(this.state.entegratorConf.identifier)}
													   {...props} />}/>
											<Route exact path="/signature/validate"
												   render={(props) => <SignatureValidator
													   currentUser={this.state.currentUser} {...props} />}/>
											{this.isEDefter('CREATE') &&
											<Route exact path="/edefter/create"
												   render={(props) => <EDefterCreatePage {...props}
																						 currentUser={this.state.currentUser}
																						 isCreditSufficient = {this.isCreditSufficient("EDEFTER")}
																						 isEDefter={this.isEDefter}
																						 soapUrl={this.state.currentUser.edefterSoapUrl}/>}/>
											}

											{
												(this.isEDefter('VIEW_ALL') || this.isEDefter('VIEW')) &&
												<Route exact path="/edefter/list"
													   render={(props) => <EDefterListPage {...props}
																						   currentUser={this.state.currentUser}
																						   isCreditSufficient = {this.isCreditSufficient("EDEFTER")}
																						   isEDefter={this.isEDefter}
																						   soapUrl={this.state.currentUser.edefterSoapUrl}/>
													   }
												/>
											}
											{(this.isEDefter('CREATE') || this.isEDefter('UPDATE_ALL') || this.isEDefter('UPDATE')) &&
											<Route exact path="/edefter/eDefterInformation"
												   render={(props) =>
													   <EDefterInformationPage {...props}
																			   isCreditSufficient = {this.isCreditSufficient("EDEFTER")}
																			   currentUser={this.state.currentUser}
																			   soapUrl={this.state.currentUser.edefterSoapUrl}/>}/>
											}

											{(this.state.currentUser.gibEDefterApplicationRequired === true) &&
												<Route exact path="/edefter/eDefterApplicationPetition"
													   render={(props) =>
														   <EDefterApplicationPetition {...props}
																					   currentUser={this.state.currentUser}
														   />}/>
											}

											{this.isEGiderPusulasi() &&
											<Route exact path="/newExpenseNote" render={(props) =>
												<NewExpenseNote
													reload={this.reload} {...props}
													name='newExpenseNote'
													isCreditSufficient = {this.isCreditSufficient("EGIDERPUSULASI")}
													currentUser={this.state.currentUser}
													initialSearchQuery={this.state.initialSearchQuery}
													removeSearchqueryProps={this.removeSearchQuery}
													showExpenseNote={this.hasSidebarMenu("ednsm_ars_expenseNoteList")}
													offsetWidth={this.state.offsetWidth}
													triggerDownloadRequestTooltip={this.triggerDownloadRequestTooltip}
													resourcePrefix={VirtualHost.conf.resourcePrefix}/>}/>
											}
											{this.isEBelge() &&
											<Route exact path="/belgeTmp" key="belgeTmpKey"
												   render={(props) => <TmpBelgeList
													   reload={this.reload}
													   currentUser={this.state.currentUser}
													   name='belgeTmp' {...props}
													   impersonateUserRoleId={this.state.impersonateUserRoleId}/>}/>
											}
											{this.isEBelge() &&
											<Route exact path="/belgeSend" key="belgeSendKey"
												   render={(props) => <TmpBelgeList
													   reload={this.reload}
													   currentUser={this.state.currentUser}
													   name='belgeSend' {...props}
													   impersonateUserRoleId={this.state.impersonateUserRoleId}/>}/>
											}
											{(this.isEBelge() || (this.isEArsiv() && showEarsivInbox(this.state.entegratorConf.identifier))) &&
											<Route exact path="/belgeIn" key="belgeInKey"
												   render={(props) => <TmpBelgeList
													   reload={this.reload}
													   currentUser={this.state.currentUser}
													   triggerDownloadRequestTooltip={this.triggerDownloadRequestTooltip}
													   name='belgeIn'
													   isCreditSufficient = {
														   this.isEArsiv() ? this.isCreditSufficient("EARSIV"):true
												       }
													   isEarsiv={this.isEArsiv()}
													   {...props}/>}/>
											}
											{this.isEBelge() &&
											<Route exact path="/COBelge" key="COBelgeKey"
												   render={(props) => <CancelObjectBelgeList
													   reload={this.reload}
													   currentUser={this.state.currentUser}
													   name='belgeIn' {...props}/>}/>
											}
											{this.isEBelge() &&
											<Route path="/createEditBelge/:recordId"
												   key="createEditBelge"
												   render={(props) =>
													   <CreateEditBelge
														   currentUser={this.state.currentUser}
														   offsetWidth={this.state.offsetWidth}
														   {...props}
													   />
												   }
											/>
											}
											{this.isEBelge() &&
											<Route path="/createQuickInvoice"
												   render={(props) => <CreateEditBelge
													   currentUser={this.state.currentUser}
													   offsetWidth={this.state.offsetWidth}
													   {...props}
												   />}/>
											}
											{this.isEBelge() &&
											<Route path="/BaBs"
												   render={(props) => <SanalBaBsList
													   currentUser={this.state.currentUser}
													   offsetWidth={this.state.offsetWidth}
													   reload={this.reload}
													   {...props}
												   />}/>
											}
											{/*{this.isEBelge() &&*/}
											{/*<Route path="/belgeOutList"*/}
											{/*	   render={(props) => <BelgeOutList*/}
											{/*		   reload={this.reload} {...props}*/}
											{/*		   offsetWidth={this.state.offsetWidth}*/}
											{/*		   currentUser={this.state.currentUser}*/}
											{/*		   initialSearchQuery={this.state.initialSearchQuery}*/}
											{/*		   removeSearchqueryProps={this.removeSearchQuery}*/}
											{/*		   name='eBelgeOutboxList'*/}
											{/*		   triggerDownloadRequestTooltip={this.triggerDownloadRequestTooltip}*/}
											{/*		   resourcePrefix={VirtualHost.conf.resourcePrefix}/>}/>*/}
											{/*}*/}

											<Route path="/voyageDocumentList"
												   render={(props) => <VoyageDocumentList
													   currentUser={this.state.currentUser}
													   offsetWidth={this.state.offsetWidth}
													   reload={this.reload}
													   {...props}
												   />}/>

											<Route path="/chemistWarehousePurchaseList"
												   render={(props) => <ChemistWarehousePurchaseList
													   offsetWidth={this.state.offsetWidth}
													   reload={this.reload}
													   currentUser={this.state.currentUser}
													   {...props}
												   />}/>
											{this.isETicaret() &&
											<Route path="/trendyolPazaryeri"
												   render={(props) => <ECommerce
													   currentUser={this.state.currentUser}
													   type={eCommerces.TRENDYOL}
													   {...props}
												   />}/>}
											{false && this.isEFatura() && this.isEArsiv() && this.isAdminUser() &&
											<Route path="/orderList"
												   render={(props) => <ECommerce
													   currentUser={this.state.currentUser}
													   offsetWidth={this.state.offsetWidth}
													   type={eCommerces.CICEKSEPETI}
													   {...props}
												   />}/>}
											{false && this.isEFatura() && this.isEArsiv() && this.isAdminUser() &&
											<Route path="/hepsiburada"
												   render={(props) => <ECommerce
													   currentUser={this.state.currentUser}
													   offsetWidth={this.state.offsetWidth}
													   type={eCommerces.HEPSIBURADA}
													   {...props}
												   />}/>}
											{false && this.isEFatura() && this.isEArsiv() && this.isAdminUser() &&
											<Route path="/n11"
												   render={(props) => <ECommerce
													   currentUser={this.state.currentUser}
													   offsetWidth={this.state.offsetWidth}
													   type={eCommerces.N11}
													   {...props}
												   />}/>}
											{false && this.isEFatura() && this.isEArsiv() && this.isAdminUser() &&
											<Route path="/pazarama"
												   render={(props) => <ECommerce
													   currentUser={this.state.currentUser}
													   offsetWidth={this.state.offsetWidth}
													   type={eCommerces.PAZARAMA}
													   {...props}
												   />}/>}
											{false && this.isEFatura() && this.isEArsiv() && this.isAdminUser() &&
											<Route path="/ikas"
												   render={(props) => <ECommerce
													   currentUser={this.state.currentUser}
													   offsetWidth={this.state.offsetWidth}
													   type={eCommerces.IKAS}
													   {...props}
												   />}/>}
											<Route path="/serviceDocumentation/listResponseCode"
												   render={(props) => <ResponseCodeList
													   isLoaded={this.sdResponseCodeListCallback}/>}/>

											{this.state.isSectionLoaded ?
												<Route path="/serviceDocumentation/listEndpoint"
													   render={(props) => <EndpointList
														   sectionId={this.state.sdSectionId}
														   isLoaded={this.sdEndpointListCallback}
														   docName={this.state.sdDocumentationName}{...props} />}/> :
												<Redirect  path="/serviceDocumentation/ListEndpoint"
														   to="/serviceDocumentation/add"/>}
											<Route path="/serviceDocumentation/DocumentationDetails/:recordId"
												   render={(props) => <DocumentationDetails
													   sectionCallback={this.sdDocumentListCallback}
													   setServiceDocumentation = {this.setServiceDocumentation}
													   getServiceDocumentation = {this.getServiceDocumentation}
													   getAllDocWithEndpoint = {this.getAllDocWithEndpoint}
													   offsetWidth={this.state.offsetWidth}
													   {...props}
												   />}/>
											<Route path="/serviceDocumentation/add"
												   render={(props) => <DocumentationList
													   sectionCallback={this.sdDocumentListCallback}
													   setServiceDocumentation = {this.setServiceDocumentation}
													   getServiceDocumentation = {this.getServiceDocumentation}
													   getAllDocWithEndpoint = {this.getAllDocWithEndpoint}
													   {...props}
													   serviceDocumentation={this.state.serviceDocumentation}
												   />}
											/>
											<Route exact path="/serviceDocumentation"
												   render={(props) =>
													   <SectionDetail
														   endpointId={this.state.sdEndpointId}
														   updateEndpoint = {this.sdSidebarCallbackFunction}
														   {...props}
													   />}
											/>
											<Route exact path="/timeline" key="timeline"
												   render={(props) => <Timeline
													   name="timeline"
													   currentUser={this.state.currentUser}
													   offsetWidth={this.state.offsetWidth}
													   reload={this.reload} {...props}
												   />}
											/>
											<Route exact path="/serviceDocumentation/method/:methodName"
												   render={(props) => <MethodDetail {...props} />}/>
											{(this.state.impersonateUserRoleId === 3 || this.state.impersonateUserRoleId === 4) &&
												<Route path="/documentStatusInfo"
													   render={(props ) => <DocumentStatusInfo
														   impersonateUserRoleId={this.state.impersonateUserRoleId}
														   currentUser={this.state.currentUser}
														   reload={this.reload}{...props}
														   name='documentStatusInfo'
														   onImpersonate={this.onImpersonate}
														   handleGoPage={this.handleGoPage}
														   onLogin={this.handleLogin}
														   showOnDocuments={false}
													   />}/>
											}

											{
											<Route path="/receiptList"
												   render={(props) => <ReceiptList
													   reload={this.reload}
													   profileId="ADISYON"
													   isCreditSufficient = {this.isCreditSufficient("ERECEIPT")}
													   initialSearchQuery={this.state.initialSearchQuery}
													   currentUser={this.state.currentUser}
													   offsetWidth={this.state.offsetWidth}
													   name='receiptList' {...props}/>}
												   />
											}

											{
												<Route path="/sigortaList"
													   render={(props) => <SigortaList
														   reload={this.reload}
														   profileId="SIGORTA"
														   isCreditSufficient = {this.isCreditSufficient("ESIGORTA")}
														   initialSearchQuery={this.state.initialSearchQuery}
														   currentUser={this.state.currentUser}
														   offsetWidth={this.state.offsetWidth}
														   name='sigortaList' {...props}/>}
												/>
											}

											{
												<Route exact path="/sigortaTmp" key="sigortaTmpKey"
													   render={(props) => <SigortaTmpList reload={this.reload}
																						  isCreditSufficient = {this.isCreditSufficient("ESIGORTA")}
																						  isEczaciKart={this.isEczaciKart()}
																						  documentType={"POLICE"}
																						  currentUser={this.state.currentUser}
																						  profileId="EARSIVBELGE"
																						  name='sigortaTmpList'
																						  {...props}
													   />} />
											}


											{
												<Route path="/createEditSigorta/:recordId"
													   key="createEditSigorta"
													   render={(props) =>
														   <CreateEditSigorta
															   currentUser={this.state.currentUser}
															   offsetWidth={this.state.offsetWidth}
															   {...props}
														   />
													   }
												/>
											}


											<Redirect exact path="/login" to="/"/>
											<Redirect exact path="/login/:username/:password" to="/"/>
											<Redirect exact path="/login/:base64login" to="/"/>
											<Route component={NotFound}/>
										</Switch>
									</Suspense>
									{this.state.queryModal &&
									<QueryEnvelopeModal
										modal={this.state.queryModal}
										toggle={this.toggleQueryEnvelopeModal}/>
									}
								</div>
								<Footer/>
							</div>
						</div>
					}
					<NotificationAlert ref="notificationAlert"/>

				</div>
				}

				{this.state.currentUser && this.state.currentUser.roleId && (this.state.currentUser.roleId === 5 || this.state.currentUser.roleId === 3 || this.state.currentUser.roleId === 4) &&
				<div>{
					<div className="wrapper">
						<Sidebar isAuthenticated={this.state.isAuthenticated}
								 impersonateUserRoleId = {this.state.impersonateUserRoleId}
								 currentUser={this.state.currentUser}
								 canToggle={this.state.canToggleSidebar}
								 history={this.props.history}
								 reload={this.reload}
								 masterSelected={this.state.sidebarSelected}
								 resetMasterSelected={() => this.setState({sidebarSelected: null})}
								 onSelectReport={this.onSelectReport}
								 onSelectExcelReport={this.onSelectExcelReport}
								 queryEnvelopeListener={this.toggleQueryEnvelopeModal}
								 setOffsetWidth={this.setOffsetWidth}
								 entegratorConf={this.state.entegratorConf}
								 decideVakifbankStyle={this.decideVakifbankStyle}
						/>
						<div className="main-panel">
							<Header isAuthenticated={this.state.isAuthenticated}
									currentUser={this.state.currentUser}
									impersonate={this.isImpersonate()}
									onImpersonate={this.onImpersonate}
									onLogin={this.handleLogin}
									reload={this.reload}
									spin={this.state.spin}
									location={this.props.location.pathname}
									onLogout={this.handleLogout}
									offsetWidth={this.state.offsetWidth}
									showDownloadRequestTooltip={this.state.showDownloadRequestTooltip}
									entegratorConf={this.state.entegratorConf}
							/>
							<div className=" panel-header-sm">
							</div>

							<div className="content" key={this.state.key} style={this.decideVakifbankStyle()}>
								<Suspense fallback={<ReactLoading type="spinningBubbles" style={{
									width: "70px",
									height: "70px",
									margin: "20px auto 0 auto",
									fill: "#888"
								}}/>}>
									<Switch currentUser={this.state.currentUser}>
										<Route exact path="/" render={(props) =>
											<HomePage isAuthenticated={this.state.isAuthenticated}
													  impersonateUserRoleId={this.state.impersonateUserRoleId}
													  currentUser={this.state.currentUser}
													  isEntegrator={this.isEntegrator()}
													  isDistributor={this.isDistributor()}
													  decideVakifbankStyle={this.decideVakifbankStyle}
													  entegratorConf={this.state.entegratorConf}
													  {...props}  />
										}
										/>
										<Route path="/customizeSidebar/:customerId?"
											   render={(props) => <SidebarCustomizer
												   offsetWidth={this.state.offsetWidth}
												   updateUserHook={this.updateSidebarMenus} {...props}/>}/>
										{this.state.currentUser.sidebarMenus['customer_actions'] === true &&
											<Route exact path="/customer" key="customerList"
												   render={(props) => <CustomerList name="customer"
																					impersonateUserRoleId={this.state.impersonateUserRoleId}
																					reload={this.reload}
																					onImpersonate={this.onImpersonate}
																					allowPrivateAccess={this.allowPrivateAccess()}
																					isEntegrator={this.isEntegrator()}
																					isDistributor={this.isDistributor()}
																					currentUser={this.state.currentUser}
																					isAdmin={this.isAdminUser()}
																					onLogin={this.handleLogin} {...props}
																					triggerDownloadRequestTooltip={this.triggerDownloadRequestTooltip}/>}/>
										}

										{((((this.isEntegrator() || this.isDistributor()) && this.isAdminUser()) || this.isTeamLeader()) || this.isCallCenter()) &&
										<Route exact path="/requestMessageList" key="requestMessageList"
											   render={(props) => <RequestMessageList name="requestMessageList"
																					  impersonateUserRoleId={this.state.impersonateUserRoleId}
																					  isEntegrator={this.isEntegrator()}
																					  currentUser={this.state.currentUser}
																					  onImpersonate={this.onImpersonate}
																					  offsetWidth={this.state.offsetWidth}
																					  onLogin={this.handleLogin} {...props}
																					  allowPrivateAccess={this.allowPrivateAccess()}
																					  reload={this.reload} {...props}/>}/>
										}
										{(this.state.currentUser.roleId === 5 || this.state.currentUser.roleId === 4) &&
										<Route path="/documentStatusInfo"
											   render={(props => <DocumentStatusInfo
												   currentUser={this.state.currentUser}
												   reload={this.reload}{...props}
												   name='documentStatusInfo'
												   onImpersonate={this.onImpersonate}
												   handleGoPage={this.handleGoPage}
												   onLogin={this.handleLogin}
												   showOnDocuments={false}
											   />)}/>
										}
										<Route exact path="/xsltYonetimi/:customerId?"
											   render={(props) => <XsltList reload={this.reload} {...props}
																			offsetWidth={this.state.offsetWidth}
																			currentUser={this.state.currentUser}/>}/>

										<Route exact path="/xsltOlustur"
											   render={(props) => <XsltDesigner {...props}
																				offsetWidth={this.state.offsetWidth}
																				currentUser={this.state.currentUser}/>}/>
										<Route path="/userProfile" key="userProfile"
											   render={(props) => <UserProfile name="userProfile"
																			   currentUser={this.state.currentUser}
																			   reload={this.reload}
																			   logOut={this.handleLogout}
																			   loadCurrentUser={this.loadCurrentUser}
																			   isEntegrator={this.isEntegrator()}
																			   isDistributor={this.isDistributor()}
																			   isAdminUser={this.isAdminUser()}
																			   impersonate={this.state.currentUser.impersonate} {...props}
											   />}/>
										<Route path="/createEditCustomer/:recordId"
											   render={(props) => <CreateEditCustomer name="createEditCustomer"
																					  loadCurrentUser={this.loadCurrentUser}
																					  currentUser={this.state.currentUser}
																					  isEntegrator={this.isEntegrator()}
																					  isAdminUser={this.isAdminUser()}
																					  isDistributor={this.isDistributor()}
																					  reload={this.reload} {...props}/>}/>
										<Route exact path="/cUserList" key="cUserList"
											   render={(props) => <CollectiveUserList name="cUserList"
																					  impersonateUserRoleId={this.state.impersonateUserRoleId}
																					  currentUser={this.state.currentUser}
																					  reload={this.reload}
																					  isAdmin={this.isAdminUser()}
																					  onLogin={this.handleLogin}
																					  onImpersonate={this.onImpersonate}
																					  allowPrivateAccess={this.allowPrivateAccess()}
																					  {...props}/>}/>

										{this.state.currentUser.hasDistributorSealAuthority &&
											<Route exact path="/financeSealList" key="financeSealList"
												   render={(props) => <FinanceSealList name="financeSealList"
																					   impersonateUserRoleId={this.state.impersonateUserRoleId}
																					   currentUser={this.state.currentUser}
																					   reload={this.reload}
																					   isAdmin={this.isAdminUser()}
																					   onLogin={this.handleLogin}
																					   onImpersonate={this.onImpersonate}
																					   allowPrivateAccess={this.allowPrivateAccess()}
																					   {...props}/>}/>
										}

										{(this.isEntegrator() || this.isDistributor()) &&
										<Route path="/customerRequestList" key="customerRequestList"
											   render={(props) => <CustomerRequestList name="customerRequestList"
																					   currentUser={this.state.currentUser}
																					   isEntegrator={this.isEntegrator()}
																					   offsetWidth={this.state.offsetWidth}
																					   onImpersonate={this.onImpersonate}
																					   onLogin={this.handleLogin} {...props}
																					   allowPrivateAccess={this.allowPrivateAccess()}
																					   reload={this.reload} {...props}/>}/>
										}
										<Route path="/gibusersI"
											   render={(props) => <GIBUserList name='invoice'
																			   reload={this.reload} {...props}/>}/>

										<Route exact path="/versionTrack" key="versionTrack"
											   render={(props) => <VersionTrack
												   name="versionTrack"
												   currentUser={this.state.currentUser}
												   isEntegrator={this.isEntegrator()}
												   offsetWidth={this.state.offsetWidth}
												   onImpersonate={this.onImpersonate}
												   onLogin={this.handleLogin} {...props}
												   allowPrivateAccess={this.allowPrivateAccess()}
												   reload={this.reload} {...props}/>}/>

										<Route path="/documentStatusInfo"
											   render={(props => <DocumentStatusInfo
												   currentUser={this.state.currentUser}
												   reload={this.reload}{...props}
												   name='documentStatusInfo'
												   onImpersonate={this.onImpersonate}
												   handleGoPage={this.handleGoPage}
												   onLogin={this.handleLogin}
												   showOnDocuments={false}
											   />)}/>

										{(this.isEntegrator() && VirtualHost.conf.resourcePrefix === "kolaysoft") &&
										<Route exact path="/smmmUsers" key="smmmUserInformation"
											   render={(props) => <SmmmUserInformationList
												   // currentUser={this.state.currentUser}
												   reload={this.reload} {...props}/>}/>
										}

										{(VirtualHost.conf.resourcePrefix === "kolaysoft" && this.isEntegrator() && this.hasSidebarMenu("ednsm_settings_sgkRanList")) &&
											<Route exact path="/sgkAppointmentList" key="sgkAppointmentList"
												   render={(props) =>
													   <SgkAppointmentList name="sgkAppointmentList"
																		   impersonateUserRoleId={this.state.impersonateUserRoleId}
																		   currentUser={this.state.currentUser}
																		   onImpersonate={this.onImpersonate}
																		   onLogin={this.handleLogin} {...props}
																		   reload={this.reload} {...props}/>}/>
										}

										<Redirect exact path="/login" to="/"/>
										<Route component={NotFound}/>
									</Switch>
								</Suspense>
								{this.state.queryModal &&
								<QueryEnvelopeModal
									modal={this.state.queryModal}
									toggle={this.toggleQueryEnvelopeModal}/>
								}

							</div>
							<Footer/>
						</div>
					</div>
				}
					<NotificationAlert ref="notificationAlert"/>

				</div>}

				{this.state.countBackModalVisible &&
				<CountBackModal
					modal={this.state.countBackModalVisible}
					toggle={this.toggleCountBackModal}
					maxIdleTimeout={this.state.maxIdleTimeout}
					countBackFrom={this.state.countBackFrom}
					handleCancel={this.handleCancel}
					handleLogout={this.handleLogout}
				/>
				}
			</React.Fragment>
		)
	}
}
export default withRouter(Master);